<template>
  <v-card-title>
    <v-container>
      <v-card class="pa-16">
        <v-card-title>
          <v-row>
            <v-col cols="6" md="6" justify="center">
              <h3>Adjust Tax Receipt</h3>
            </v-col>
            <v-col cols="6" md="6">
              <v-row justify="end" class="mr-1 mt-2">
                <h5>No. {{ showinv_rid }}</h5>
              </v-row>
              <v-row justify="end" class="mt-8">
                <v-btn depressed class="mx-2" color="blue darken-1" outlined @click="onClicktoPrint()">
                  print Receipt
                </v-btn>
              </v-row>
            </v-col>
          </v-row>
        </v-card-title>

        <br />
        <v-row>
          <v-col cols="12" md="2">
            <v-text-field v-model="customer_code" outlined dense disabled label="Client Code"
              background-color="#F5F5F5"></v-text-field>
          </v-col>

          <v-col cols="12" md="6">
            <v-text-field v-model="customer_name" outlined dense disabled label="Client Name"
              background-color="#F5F5F5"></v-text-field>
          </v-col>

          <v-col cols="12" md="4">
            <v-text-field v-model="doc_ref" outlined dense label="Document Reference" background-color="#F5F5F5"
              disabled></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="8">
            <v-text-field v-model="invoice_address" outlined dense label="Invoice Address" background-color="#F5F5F5"
              disabled></v-text-field>
          </v-col>
          <v-col cols="12" md="4">
            <v-text-field v-model="currency" outlined dense label="Currency" background-color="#F5F5F5"
              disabled></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="3">
            <v-text-field v-model="tax_id" outlined dense label="Tax ID " background-color="#F5F5F5"
              disabled></v-text-field>
          </v-col>

          <v-col cols="12" sm="3">
            <v-text-field v-model="branch" outlined dense label="Branch" background-color="#F5F5F5"
              disabled></v-text-field>
          </v-col>
          <v-col cols="12" md="3">
            <v-text-field v-model="payment_term" outlined dense disabled background-color="#F5F5F5"
              label="Payment Term (Day)"></v-text-field>
          </v-col>

          <v-col cols="12" sm="3">
            <v-text-field v-model="vat" outlined dense disabled label="Vat (%)"
              background-color="#F5F5F5"></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="3">
            <v-text-field v-model="po_no" outlined dense label="PO NO." background-color="#F5F5F5"
              disabled></v-text-field>
          </v-col>
          <v-col cols="12" md="3">
            <v-text-field v-model="attention" outlined dense label="Attention" background-color="#F5F5F5"
              disabled></v-text-field>
          </v-col>
          <v-col cols="12" md="3">
            <v-text-field type="number" min="0" v-model="exchange_rate" outlined dense
              label="Exchange Rate"></v-text-field>
          </v-col>
          <v-col cols="12" md="3">
            <v-menu v-model="menu2" :close-on-content-click="false" :nudge-right="40" transition="scale-transition"
              offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-text-field v-model="computedDateFormatted" :disabled="status_check" label="Date."
                  append-icon="mdi-calendar" readonly dense outlined v-bind="attrs" v-on="on"></v-text-field>
              </template>

              <v-date-picker v-model="date_rc" @input="menu2 = false"></v-date-picker>
            </v-menu>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="3">
            <v-select @change="onSelectvat_type()" outlined :items="vat_type_list" v-model="vat_type" item-value="id"
              item-text="name" label="Vat Type" dense disabled></v-select>
          </v-col>
        </v-row>
        <template>
          <template>
            <v-data-table :headers="headers" :items="mDataArray" sort-by="calories" class="elevation-1 ">
              <template v-slot:no-data>
                <v-btn color="primary" @click="initialize">
                  Reset
                </v-btn>
              </template>
              <template v-slot:item.actions="{ item }">
                <!-- <v-icon small class="mr-2" @click="editItem(item)">
                          mdi-pencil
                        </v-icon> -->

                <v-icon :style="{
                  backgroundColor: '#E1F5FE',
                  color: '#2196F3',
                }" @click="openeditItem(item)">
                  mdi-pencil
                </v-icon>

                <v-icon class="ml-2" :style="{
                  backgroundColor: '#FFEBEE',
                  color: '#F44336',
                }" @click="deleteItem(item)">
                  mdi-delete
                </v-icon>
              </template>
            </v-data-table>
          </template>
        </template>
        <br />
        <!-- tatal -->
        <v-row justify="center" align="center">
          <v-col cols="12" md="9">
            <div align="end">
              <h5>Sub Total :</h5>
            </div>
          </v-col>
          <v-col cols="12" md="3">
            <div align="end" class="mt-5">
              <v-text-field reverse v-model="inv_subtotal" outlined dense background-color="#F5F5F5"
                disabled></v-text-field>
            </div>
          </v-col>
        </v-row>
        <v-row class="mt-1">
          <v-col cols="12" md="9">
            <div align="end">
              <h5>Less Withholding Tax {{ wth_rate }} % :</h5>
            </div>
          </v-col>
          <v-col cols="12" md="3">
            <div align="end">
              <v-text-field reverse v-model="wth_ratetotal" outlined dense background-color="#F5F5F5"
                disabled></v-text-field>
            </div>
          </v-col>
        </v-row>
        <v-row class="mt-1">
          <v-col cols="12" md="9">
            <div align="end">
              <h5>Vat {{ vat }} % :</h5>
            </div>
          </v-col>
          <v-col cols="12" md="3">
            <div align="end">
              <v-text-field reverse v-model="tax_ratetotal" outlined dense background-color="#F5F5F5"
                disabled></v-text-field>
            </div>
          </v-col>
        </v-row>
        <v-row class="mt-1">
          <v-col cols="12" md="9">
            <div align="end">
              <h5>Grand Total :</h5>
            </div>
          </v-col>
          <v-col cols="12" md="3">
            <div align="end">
              <v-text-field reverse v-model="amount_total" outlined dense background-color="#F5F5F5"
                disabled></v-text-field>
            </div>
          </v-col>
        </v-row>
        <!-- total amount_total -->
        <v-row>
          <v-col cols="6" md="6" justify="center">
            <span>Payment Conditions:</span>
          </v-col>
          <v-col cols="6" md="6"> </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" md="12" justify="center">
            <v-radio-group v-model="payment_by">
              <v-row>
                <v-col cols="12" md="2">
                  <v-radio key="cash" label="Cash/เงินสด" value="cash"></v-radio>
                </v-col>
                <v-col cols="12" md="3">
                  <v-radio key="Bank" label="Bank Transfer/โอนเงิน" value="Bank"></v-radio>
                </v-col>
                <v-col cols="12" md="3">
                  <v-radio key="cheque" label="Bank Cheque/เช็คธนาคาร" value="cheque"></v-radio>
                </v-col>
              </v-row>
            </v-radio-group>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="2">
            <h5>Bank Name :</h5>
          </v-col>
          <v-col cols="12" md="4" align="start">
            <v-text-field v-model="bank_name" outlined dense></v-text-field>
          </v-col>
          <v-col cols="12" md="2" align="end">
            <h5>No./เลขที่ :</h5>
          </v-col>
          <v-col cols="12" md="4">
            <v-text-field v-model="bank_no" outlined dense></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="4">
            <h5>Payment Details/รายละเอียด :</h5>
          </v-col>
          <v-col cols="12" md="8">
            <v-textarea v-model="payment_comment" multi-line outlined dense rows="2"></v-textarea>
          </v-col>
        </v-row>
        <br />
        <hr />
        <br />
        <div>
          <v-row>
            <v-col align="center" cols="12" md="12">
              <!-- <v-btn
                  :disabled="status_check"
                  class="mr-5 buttonblue"
                  color="#689ADE"
                  @click="saveinvDraft()"
                >
                  Draft
                </v-btn> -->
              <v-btn depressed class="mr-5 buttonblue" @click="saveinvSubmit()">
                Submit
              </v-btn>
              <v-btn depressed class="mr-5 " style="
                    background-color: #9e3b1b;
                    color: white;
                  " @click="saveCancel()">
                Cancel
              </v-btn>
            </v-col>
          </v-row>
        </div>
      </v-card>
      <v-dialog v-model="dialogEdit" max-width="800px">
        <v-card class="pa-8">
          <v-card-title class="text-h6">Service No.{{ dataedit_service.inv_seq }}</v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-textarea v-model="dataedit_service.inv_detail" multi-line outlined dense
                  label="Service Details"></v-textarea>
              </v-row>
              <v-row>
                <v-col cols="12" md="4">
                  <v-text-field min="0" label="Qty" @click="calserviceamount()" @keyup="calserviceamount()"
                    v-model="dataedit_service.inv_qty" outlined dense></v-text-field>
                </v-col>

                <v-col cols="12" md="4">
                  <v-text-field label="Price Per Unit" @click="calserviceamount()" @keyup="calserviceamount()"
                    v-model="dataedit_service.inv_price" outlined dense></v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field label="Total Price" v-model="dataedit_service.inv_lineamount" outlined dense
                    background-color="#F5F5F5" disabled></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn depressed width="100" class="mr-3 buttonblue" @click="saveeditItem()">
              Save
            </v-btn>
            <v-btn depressed outlined width="100" @click="closeeditItem()">
              Cancel
            </v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogDeleteServic" max-width="500px">
        <v-card>
          <v-card-title class="text-h5">Are you sure you want to delete this item?</v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="closeDeleteService">Cancel</v-btn>
            <v-btn color="blue darken-1" text @click="deleteItemConfirm">OK</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogDeleteRecevie" max-width="600px" min-width="600px">
        <v-card>
          <v-card-title class="text-h5">Are you sure you want to Cancel this Receicpt ?</v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn color="red darken-1" text @click="deleteReceiveConfirm">OK</v-btn>
            <v-btn color="blue darken-1" text @click="closeDeleteRecive">Cancel</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-row justify="center">
        <v-dialog v-model="dialogSelectPrint" scrollable max-width="300px">
          <!-- <template v-slot:activator="{ on, attrs }">
                  <v-btn color="primary" dark v-bind="attrs" v-on="on">
                    Open Dialog
                  </v-btn>
                </template> -->
          <v-card>
            <v-card-title>Select Form</v-card-title>
            <v-divider></v-divider>
            <v-card-text style="height: auto;">
              <v-radio-group v-model="dialogSelect" column>
                <v-radio label="Summary Recevice" value="1" se></v-radio>
                <v-radio label="Detail Recevice" value="2"></v-radio>
              </v-radio-group>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-btn color="blue darken-1" outlined @click="dialogSelectPrint = false">
                Cancel
              </v-btn>
              <v-btn color="blue darken-1" outlined @click="printReceive">
                OK
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
      <!-- sumary print  start-->
      <template>
        <div v-if="datashowAll.length >= 0 || pageAll >= 0" id="mydivhtmltobase" :style="showprint">
          <PrintReceiptDejTab v-if="getcompany_id == 1" :datashowAll="datashowAll" :print_header="print_header"
            :heighttabledetail="heighttabledetail" :currency_print="currency_print" :check_cus_name="check_cus_name"
            :textamount_total_en="textamount_total_en" :checklawoffice="checklawoffice" :exchange_rate="exchange_rate"
            :branch_cus="branch_cus" :payment_by_print="payment_by_print" :bank_name_show="bank_name_show"
            :bank_no_show="bank_no_show"></PrintReceiptDejTab>
          <PrintReceiptStandardTab v-if="getcompany_id !== 1" :datashowAll="datashowAll" :print_header="print_header"
            :heighttabledetail="heighttabledetail" :currency_print="currency_print" :check_cus_name="check_cus_name"
            :textamount_total_en="textamount_total_en" :checklawoffice="checklawoffice" :exchange_rate="exchange_rate"
            :branch_cus="branch_cus" :payment_by_print="payment_by_print" :bank_name_show="bank_name_show"
            :bank_no_show="bank_no_show"></PrintReceiptStandardTab>
        </div>
      </template>
      <!-- sumary print end -->
      <!-- detail print start -->
      <template>
        <div v-if="datashowAllDetail.length >= 0 || pageAllDetail >= 0" id="mydivhtmltobaseDetail"
          :style="showprintDetail">
          <PrintReceiptDetailDejTab v-if="getcompany_id == 1" :datashowAllDetail="datashowAllDetail"
            :print_detail_header="print_detail_header" :heighttabledetail="heighttabledetail"
            :currency_print="currency_print" :check_cus_name="check_cus_name" :textamount_total_en="textamount_total_en"
            :checklawoffice="checklawoffice" :exchange_rate="exchange_rate" :branch_cus="branch_cus"
            :payment_by_print="payment_by_print" :bank_name_show="bank_name_show" :bank_no_show="bank_no_show"
            :currency_show="currency_show"></PrintReceiptDetailDejTab>
          <PrintReceiptDetailStandardTab v-if="getcompany_id !== 1" :datashowAllDetail="datashowAllDetail"
            :print_detail_header="print_detail_header" :heighttabledetail="heighttabledetail"
            :currency_print="currency_print" :check_cus_name="check_cus_name" :textamount_total_en="textamount_total_en"
            :checklawoffice="checklawoffice" :exchange_rate="exchange_rate" :branch_cus="branch_cus"
            :payment_by_print="payment_by_print" :bank_name_show="bank_name_show" :bank_no_show="bank_no_show"
            :currency_show="currency_show"></PrintReceiptDetailStandardTab>
        </div>
      </template>
      <!-- detail print end -->
      <SuccessDialog :status="dialogAdd" :text_color="text_color" :title="title" :message="message" />

      <SuccessDialogPush :status="dialogAdd" :text_color="text_color" :title="title" :message="message" :link="link" />
    </v-container>
  </v-card-title>
</template>

<script>
import api from "@/services/api";
import { server } from "@/services/constants";
import { language } from "../language/Leavelist.js";
import html2pdf from "html2pdf.js";
import StockCard from "@/components/cards/StockCard";
import SuccessDialog from "@/components/cards/SuccessDialog";
import SuccessDialogPush from "@/components/cards/SuccessDialogPush";
import { imageUrl } from "@/services/constants";
import {
  tolocalestringnumber,
  stringcommatonumber,
} from "../computing/tolocalestringnumber";
import PrintReceiptDejTab from "./PrintReceiptDejTab";
import PrintReceiptStandardTab from "./PrintReceiptStandardTab";
import PrintReceiptDetailDejTab from "./PrintReceiptDetailDejTab";
import PrintReceiptDetailStandardTab from "./PrintReceiptDetailStandardTab";
var convert = require("decimal-number-to-words");
import unity from "@/unity/unity";

import { generateReceiptPDF } from "@/utils/pdfReceiptGenerator";

import {
  generateReceiptDetailPDF,
  downloadReceiptDetailPDF,
  printReceiptDetailPDF,
} from "@/utils/pdfReceiptDetailGenerator";

export default {
  name: "NewAdvance",
  data() {
    return {
      pdfMakeReady: false,
      mockData: {
        main_data: null, // จะโยนค่าเข้ามาตอนเรียกใช้
        main_data_detail: null, // เพิ่มบรรทัดนี้สำหรับ Detail Receipt
      },

      getcompany_id: localStorage.getItem(server.COMPANYID),
      currency_print: "",
      vat_type_list: [
        { id: "I", name: "Include Vat" },
        { id: "E", name: "Exclude Vat" },
      ],
      check_cus_name: false,
      date_rc: null,
      menu2: false,
      bank_name_show: "",
      bank_no_show: "",
      bank_name: "",
      bank_no: "",
      showinv_rid: "####",
      status_check: false,
      main_id: 0,
      main_customer_id: 0,
      dataAddRc_H: {},
      dataAddRc_D: {},
      payment_by: "",
      payment_comment: "",
      company_trc: "",
      customer_data: [],
      main_inv_id: [],
      res_amout: [],
      res_docRef: [],
      res_so_detail: [],
      res_ts_detail: [],
      res_ad_detail: [],
      res_ms_detail: [],
      dataAll: [],
      desserts: [],
      mDataArray: [],
      customer_code: "",
      customer_name: "",
      doc_ref: "",
      inv_id_by: 0,
      invoice_address: "",
      currency: "",
      tax_id: "",
      branch: "",
      exchange_rate: 0,
      vat_type: "",
      wth_rate: 0,
      wth_ratetotal: 0,
      tax_ratetotal: 0,
      amount_total: 0,
      inv_subtotal: 0,
      payment_term: 0,
      amoumt_t: 0,
      attention: "",
      vat: "",
      po_no: "",
      headers: [
        {
          text: "No.",
          value: "inv_seq",
          class: "bg-colorth texttablehcenter ",
          width: "8%",
          align: "start",
          divider: true,
          sortable: false,
        },
        {
          text: "Service Details",
          align: "center",
          value: "inv_detail",
          class: "bg-colorth texttablehcenter",
          width: "35%",
          align: "start",
          divider: true,
          sortable: false,
        },
        {
          text: "Qty",
          value: "inv_qty",
          class: "bg-colorth texttablehcenter ",
          width: "15%",
          divider: true,
          align: "end",
          sortable: false,
        },

        {
          text: "Price Per Unit",
          value: "inv_price",
          class: "bg-colorth texttablehcenter",
          width: "15%",
          divider: true,
          align: "end",
          sortable: false,
        },
        {
          text: "Total Price  ",
          value: "inv_lineamount",
          class: "bg-colorth texttablehcenter",
          width: "15%",
          divider: true,
          align: "end",
          sortable: false,
        },
        {
          value: "actions",
          class: "bg-colorth texttablehcenter",
          align: "center",
          width: "60px",
          divider: true,
          sortable: false,
        },
      ],
      dialogAdd: false,
      text_color: "text-h5 green--text text-center",
      title: "green",
      message: "green",
      link: "",
      dialogEdit: false,
      dataedit_service: {
        inv_lineamount: 0,
      },
      editedIndex: -1,
      dialogDeleteServic: false,
      dialogDeleteRecevie: false,
      //print va start
      setlanguage: language.en,
      dialogSelectPrint: false,
      dialogSelect: "1",

      currency_show: "",
      payment_by_print: "",
      main_id_print: 0,
      inv_id: 0,
      inv_detail_id: 0,
      tax_detail_rate: 0,
      showprint: "",
      showprintDetail: "",
      textamount_total_en: "",
      print_header_list: [
        {
          id: "1",
          com_title: "RECEIPT / TAX INVOICE",
          com_title_th: "ใบเสร็จรับเงิน / ใบกำกับภาษี",
          com_name: "",
          inv_company_name_th: "",
          inv_company_address: "",
          inv_company_branch: "",
          inv_company_tel: "",
          inv_company_email: "",
          inv_tax_id: "",
          com_eng_1: "DEJ-UDOM & ASSOCIATES LTD.",
          com_eng_2: "ATTORNEYS AT LAW",
          com_thai: "บริษัท เดชอุดม แอนด์ แอสโซซิเอทส์ จำกัด",
          com_add_name: "CHARN ISSARA TOWER 1, 2nd FLOOR,",
          com_add_no: "942/69 RAMA IV ROAD,",
          com_add_city: "KWAENG SURIYAWONG, KHET BANGRAK,",
          com_add_country: "BANGKOK 10500, THAILAND",
          com_add_tel: "Tel : 0-2233-0055, 0-2267-5152",
          com_add_email: "E-MAIL : account@dejudom.com",
          com_add_tax_id: `TAX ID. No. 0105534015348/"HEAD OFFICE"`,
        },
        {
          id: "2",
          com_title: "RECEIPT",
          com_title_th: "ใบเสร็จรับเงิน",
          com_name: "",
          inv_company_name_th: "",
          inv_company_address: "",
          inv_company_branch: "",
          inv_company_tel: "",
          inv_company_email: "",
          inv_tax_id: "",
          com_eng_1: "DEJ-UDOM & ASSOCIATES",
          com_eng_2: "ATTORNEYS AT LAW",
          com_thai: "สำนักกฎหมาย เดชอุดม แอนด์ แอสโซซิเอทส์",
          com_add_name: "CHARN ISSARA TOWER 1, 2nd FLOOR,",
          com_add_no: "942/69 RAMA IV ROAD,",
          com_add_city: "KWAENG SURIYAWONG, KHET BANGRAK,",
          com_add_country: "BANGKOK 10500, THAILAND",
          com_add_tel: "Tel : 0-2233-0055, 0-2267-5152",
          com_add_email: "E-MAIL : account@dejudom.com",
          com_add_tax_id: `TAX ID. No. 0992000028227/"HEAD OFFICE"`,
        },
      ],

      print_header_list_detail: [
        {
          id: "1",
          com_title: "RECEIPT / TAX INVOICE",
          com_title_th: "ใบเสร็จรับเงิน / ใบกำกับภาษี",
          com_name: "",
          inv_company_name_th: "",
          inv_company_address: "",
          inv_company_branch: "",
          inv_company_tel: "",
          inv_company_email: "",
          inv_tax_id: "",
          com_eng_1: "DEJ-UDOM & ASSOCIATES LTD.",
          com_eng_2: "ATTORNEYS AT LAW",
          com_thai: "บริษัท เดชอุดม แอนด์ แอสโซซิเอทส์ จำกัด",
          com_add_name: "CHARN ISSARA TOWER 1, 2nd FLOOR,",
          com_add_no: "942/69 RAMA IV ROAD,",
          com_add_city: "KWAENG SURIYAWONG, KHET BANGRAK,",
          com_add_country: "BANGKOK 10500, THAILAND",
          com_add_tel: "Tel : 0-2233-0055, 0-2267-5152",
          com_add_email: "E-MAIL : account@dejudom.com",
          com_add_tax_id: `TAX ID. No. 0105534015348/"HEAD OFFICE"`,
        },
        {
          id: "2",
          com_title: "RECEIPT",
          com_title_th: "ใบเสร็จรับเงิน",
          com_name: "",
          inv_company_name_th: "",
          inv_company_address: "",
          inv_company_branch: "",
          inv_company_tel: "",
          inv_company_email: "",
          inv_tax_id: "",
          com_eng_1: "DEJ-UDOM & ASSOCIATES",
          com_eng_2: "ATTORNEYS AT LAW",
          com_thai: "สำนักกฎหมาย เดชอุดม แอนด์ แอสโซซิเอทส์",
          com_add_name: "CHARN ISSARA TOWER 1, 2nd FLOOR,",
          com_add_no: "942/69 RAMA IV ROAD,",
          com_add_city: "KWAENG SURIYAWONG, KHET BANGRAK,",
          com_add_country: "BANGKOK 10500, THAILAND",
          com_add_tel: "Tel : 0-2233-0055, 0-2267-5152",
          com_add_email: "E-MAIL : account@dejudom.com",
          com_add_tax_id: `TAX ID. No. 0992000028227/"HEAD OFFICE"`,
        },
      ],
      print_header: null,
      print_detail_header: null,
      print_table_detail: [],
      print_table_Rcdetail: [],
      pageAll: 1,
      pageAllDetail: 1,
      opensummarize: false,
      opensummarizeDetail: false,
      datashowAll: [],
      datashowAllDetail: [],
      dataforshowprpo: [],
      setdatatoshow: [],
      setdatatoshowDetail: [],
      branch_cus: "",
      checklawoffice: false,
      heighttabledetail: "0px",
      //print va end
    };
  },
  components: {
    StockCard,
    SuccessDialog,
    SuccessDialogPush,
    PrintReceiptDejTab,
    PrintReceiptStandardTab,
    PrintReceiptDetailDejTab,
    PrintReceiptDetailStandardTab,
  },
  computed: {
    version() {
      return this.initial_data;
    },
    computedDateFormatted() {
      return unity.formatDate(this.date_rc);
    },

    dataToUse() {
      return this.mockData.main_data || {};
    },

    header() {
      return this.dataToUse.print_header || {};
    },

    items() {
      const datashowAll = this.dataToUse.datashowAll || [];
      const allItems = [];

      datashowAll.forEach((group) => {
        if (Array.isArray(group)) {
          group.forEach((item) => {
            allItems.push(item);
          });
        }
      });

      return allItems;
    },

    currencyPrint() {
      return this.dataToUse.currency_print || "";
    },

    exchangeRate() {
      return this.dataToUse.exchange_rate || "";
    },

    showCurrencyColumn() {
      const curr = this.currencyPrint.toUpperCase();
      return curr === "US" || curr === "USD";
    },

    dataToUseDetail() {
      return this.mockData.main_data_detail || {};
    },

    headerDetail() {
      return this.dataToUseDetail.print_header || {};
    },

    itemsDetail() {
      const datashowAllDetail = this.dataToUseDetail.datashowAllDetail || [];
      const allItems = [];

      datashowAllDetail.forEach((group) => {
        if (Array.isArray(group)) {
          group.forEach((item) => {
            allItems.push(item);
          });
        }
      });

      return allItems;
    },

    currencyPrintDetail() {
      return this.dataToUseDetail.currency_print || "";
    },

    exchangeRateDetail() {
      return this.dataToUseDetail.exchange_rate || "";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
  },

  async mounted() {
    this.$forceUpdate();
    const userId = localStorage.getItem(server.USER_ID);
    if (userId && api.isLoggedIn()) {
      // this.$router.push("/");
    } else {
      this.$store.state.isLogged = false;
      this.$router.push("/login");
    }
    await this.loaddataRc();
    await this.loadCustomer();
    await this.loaddataRc_D();
    await this.loadInvByID();
    this.waitForPdfMakeReady()
      .then(() => {
        this.pdfMakeReady = true;
        console.log("✅ pdfMake พร้อมใช้งาน");
      })
      .catch((error) => {
        console.error("❌ เกิดข้อผิดพลาด:", error);
        alert("ไม่สามารถโหลด pdfMake ได้ กรุณาลองใหม่อีกครั้ง");
      });

    this.$hideLoader();
  },
  methods: {
    // print start

    async onClicktoPrint() {
      this.dialogSelectPrint = true;
      this.main_id_print = this.$route.params.id;
    },

    //print sumary start
    async loadRef_TypeRcById() {
      this.print_header = {};
      const res_inv_id = await api.billing_expensegetDataReceiveDByIDOne(this.main_id_print);

      this.inv_id = res_inv_id.data[0].inv_hid;
      this.tax_rate = res_inv_id.data[0].tax_rate;
      this.payment_by_print = res_inv_id.data[0].payment_by;
      this.bank_name_show = res_inv_id.data[0].bank_name;
      this.bank_no_show = res_inv_id.data[0].bank_no;
      const res_hresult = await api.billing_expense_getdataByIdInvoice_HRC(
        res_inv_id.data[0].inv_hid,
      );

      if (res_hresult.data[0].company_inv == "D") {
        this.getcompany_id = 1;
        this.print_header = this.print_header_list[0];
        this.checklawoffice = false;
        this.heighttabledetail = "270px";
        this.print_header.com_title = "RECEIPT / TAX INVOICE";
        this.print_header.com_title_th = "ใบเสร็จรับเงิน / ใบกำกับภาษี";
      } else if (res_hresult.data[0].company_inv == "L") {
        this.getcompany_id = 1;
        this.print_header = this.print_header_list[1];
        this.checklawoffice = true;
        this.heighttabledetail = "300px";
        this.print_header.com_title = "RECEIPT";
        this.print_header.com_title_th = "ใบเสร็จรับเงิน";
      } else {
        this.print_header.inv_company_address2 = res_hresult.data[0].inv_company_address2;
        this.print_header.inv_subdistrict = res_hresult.data[0].inv_subdistrict;
        this.print_header.inv_district = res_hresult.data[0].inv_district;
        this.print_header.inv_province = res_hresult.data[0].inv_province;
        this.print_header.inv_postcode = res_hresult.data[0].inv_postcode;
        this.print_header.inv_country = res_hresult.data[0].inv_country;

        this.getcompany_id = res_hresult.data[0].company_inv;
        this.heighttabledetail = "365px";
        this.print_header.com_title = "RECEIPT / TAX INVOICE";
        this.print_header.com_title_th = "ใบเสร็จรับเงิน / ใบกำกับภาษี";
        this.print_header.com_name = res_hresult.data[0].com_name;
        this.print_header.inv_company_address =
          res_hresult.data[0].inv_company_address;
        this.print_header.inv_company_branch =
          res_hresult.data[0].inv_company_branch;
        this.print_header.inv_company_tel = res_hresult.data[0].inv_company_tel;
        this.print_header.inv_company_email =
          res_hresult.data[0].inv_company_email;
        this.print_header.inv_tax_id = res_hresult.data[0].inv_tax_id;
        this.print_header.inv_company_name_th =
          res_hresult.data[0].inv_company_name_th;
      }
      this.print_header.company_inv = res_hresult.data[0].company_inv;
      if (res_inv_id.data[0].payment_by == "cash") {
        this.print_header.payment_by = "Cash";
      } else if (res_inv_id.data[0].payment_by == "Bank") {
        this.print_header.payment_by = "Transfer";
      } else if (res_inv_id.data[0].payment_by == "cheque") {
        this.print_header.payment_by = "Cheque";
      } else {
        this.print_header.payment_by = "Other";
      }
      this.print_header.payment_detail = res_inv_id.data[0].payment_comment;
      this.print_header.inv_id = res_inv_id.data[0].trc_id;

      this.print_header.invoice_date = res_hresult.data[0].date_show;

      this.print_header.wth_rate = res_hresult.data[0].wth_rate;
      this.print_header.tax_rate = this.tax_rate;
      this.print_header.wth_rate_amount = parseFloat(
        (res_hresult.data[0].sub_total * res_hresult.data[0].wth_rate) / 100,
      );
    },
    async loadMainInvSoData() {
      // var tmp_inv_data;
      // this.print_header = {};
      const res_inv_so = await api.billing_expense_getdataByIdInvoice_HRC(this.inv_id);

      if (res_inv_so.data[0].company_inv == "D") {
        this.getcompany_id = 1;
        this.print_header = this.print_header_list[0];
        this.print_header.com_title = "RECEIPT / TAX INVOICE";
        this.print_header.com_title_th = "ใบเสร็จรับเงิน / ใบกำกับภาษี";
      } else if (res_inv_so.data[0].company_inv == "L") {
        this.getcompany_id = 1;
        this.print_header = this.print_header_list[1];
        this.print_header.com_title = "RECEIPT";
        this.print_header.com_title_th = "ใบเสร็จรับเงิน";
      } else {
        this.getcompany_id = res_inv_so.data[0].company_inv;
        this.print_header.com_title = "RECEIPT / TAX INVOICE";
        this.print_header.com_title_th = "ใบเสร็จรับเงิน / ใบกำกับภาษี";
        this.print_header.com_name = res_inv_so.data[0].com_name;
        this.print_header.inv_company_address =
          res_inv_so.data[0].inv_company_address;
        this.print_header.inv_company_branch =
          res_inv_so.data[0].inv_company_branch;
        this.print_header.inv_company_tel = res_inv_so.data[0].inv_company_tel;
        this.print_header.inv_company_email =
          res_inv_so.data[0].inv_company_email;
        this.print_header.inv_tax_id = res_inv_so.data[0].inv_tax_id;
        this.print_header.inv_company_name_th =
          res_inv_so.data[0].inv_company_name_th;
      }
      this.currency_show = res_inv_so.data[0].currency;
      this.print_header.customer_name = res_inv_so.data[0].customer_name;
      // this.print_header.invoice_date = res_inv_so.data[0].date;
      this.print_header.addressall = res_inv_so.data[0].addressall;
      this.print_header.customer_address = res_inv_so.data[0].customer_address;

      this.print_header.province_invoice = res_inv_so.data[0].province_invoice;
      this.print_header.country_invoice = res_inv_so.data[0].country_invoice;
      this.print_header.zipcode_invoice = res_inv_so.data[0].zipcode_invoice;

      this.print_header.period_cover = res_inv_so.data[0].inv_id
        ? res_inv_so.data[0].inv_id
        : res_inv_so.data[0].pinv_id;
      this.print_header.customer_contact_name =
        res_inv_so.data[0].customer_contact_name;
      this.print_header.customer_taxid = res_inv_so.data[0].customer_taxid;
      this.branch_cus = res_inv_so.data[0].customer_branch;
      this.print_header.tax_rate = this.tax_rate;
      // alert(this.branch_cus)
    },
    async loadInvSoData() {
      //data in table
      var tmp_inv_data;
      var sub_total = 0;

      const res_inv_rc = await api.billing_expensegetDataPrint(this.main_id_print);

      tmp_inv_data = res_inv_rc.data;

      tmp_inv_data.forEach((item, index) => {
        var data = {
          no: 0,
          inv_id: "",
          date: null,
          credit_term: 0,
          currency: "",
          amount: 0,
        };

        data.no = index + 1;
        data.inv_id = item.inv_id;
        data.date = item.date_show;
        data.credit_term = item.credit_term;
        data.currency = item.currency;

        data.amount = Number(item.amount);
        if (this.vat_type == "E") {
          data.amount_s = Number(item.amount);
        } else if (this.vat_type == "I") {
          data.amount_s = Number(item.amount);
        } else {
          return;
        }
        data.amount_s = parseFloat(data.amount_s);
        this.print_table_detail.push(data);
        sub_total = Number(sub_total) + Number(data.amount);
      });
      sub_total = sub_total.toFixed(2);

      if (this.vat_type == "E") {
        this.print_header.sub_total = parseFloat(Number(sub_total).toFixed(2));
        this.print_header.tax_rate_amount = parseFloat(
          Number((this.print_header.sub_total * this.vat) / 100).toFixed(2),
        );
        this.print_header.amount_total = parseFloat(
          Number(this.print_header.sub_total) +
          Number(this.print_header.tax_rate_amount),
        );
        console.log(
          "this.print_header.sub_total: " + this.print_header.sub_total,
        );
        console.log(
          "this.print_header.tax_rate_amount: " +
          this.print_header.tax_rate_amount,
        );
      } else if (this.vat_type == "I") {
        this.print_header.amount_total = parseFloat(sub_total);
        this.print_header.sub_total = parseFloat(
          (sub_total * 100) / (100 + Number(this.vat)),
        );
        this.print_header.tax_rate_amount = parseFloat(
          this.print_header.amount_total - this.print_header.sub_total,
        );
      } else {
        return;
      }

      const checker_th = /([\u0E00-\u0E7F]+)/gmu;
      let matches = this.print_header.customer_name.match(checker_th);
      // const checker_th = /([\u0E00-\u0E7F]+)/gmu;
      if (matches) {
        this.check_cus_name = false;
      } else {
        this.check_cus_name = true;
      }

      if (this.check_cus_name) {
        this.textamount_total_en = convert.toWords(
          this.print_header.amount_total.toFixed(2),
        );
        let setcheckscratch = false;
        this.textamount_total_en = this.textamount_total_en.replace(
          /\b./g,
          function (m) {
            if (m == ",") {
              return "";
            }
            if (m == "-") {
              setcheckscratch = true;
              return m;
            } else {
              if (setcheckscratch) {
                setcheckscratch = false;
                return m;
              }
              setcheckscratch = false;
              return m.toUpperCase();
            }
          },
        );
      } else {
        //start เปลี่ยนเป็นตัวอ่านไทย
        // อาเรย์สำหรับแปลงตัวเลขเป็นข้อความไทย
        let thaiNumbers = [
          "",
          "หนึ่ง",
          "สอง",
          "สาม",
          "สี่",
          "ห้า",
          "หก",
          "เจ็ด",
          "แปด",
          "เก้า",
        ];
        let thaiUnits = ["", "สิบ", "ร้อย", "พัน", "หมื่น", "แสน", "ล้าน"];

        // แยกตัวจำนวนเต็มและทศนิยมห
        this.print_header.amount_total =
          Math.round(this.print_header.amount_total * 100) / 100;
        let [
          integerPart,
          decimalPart,
        ] = this.print_header.amount_total.toString().split(".");

        // แปลงส่วนทศนิยมเป็นข้อความไทย (สตางค์)
        let de_check = 0;

        if (decimalPart) {
          if (decimalPart.split("").length == 1) {
            if (Number(decimalPart) >= 10) {
              decimalPart = decimalPart;
            } else if (Number(decimalPart) > 0) {
              decimalPart = Number(decimalPart) * 10;
            } else {
              de_check = 1;
            }
          }
        } else {
          de_check = 1;
        }
        let decimalText = "";
        if (de_check == 0) {
          decimalPart = String(decimalPart);

          let numArrays = decimalPart.split("").map(Number);
          numArrays.forEach((num, index) => {
            let units = thaiUnits[numArrays.length - index - 1];
            let digits = thaiNumbers[num];
            if (num !== 0) {
              if (num === 1 && index === numArrays.length - 1) {
                // ตรวจสอบว่าเป็นตำแหน่งสุดท้าย
                decimalText += "เอ็ด" + units;
              } else if (
                num === 2 &&
                index === numArrays.length - 2 &&
                numArrays.length >= 2
              ) {
                decimalText += "ยี่" + units;
              } else if (
                num === 1 &&
                index === numArrays.length - 2 &&
                numArrays.length >= 2
              ) {
                decimalText += units;
              } else {
                decimalText += digits + units;
              }
            }
          });

          decimalText = decimalText + "สตางค์";
        }

        // แปลงส่วนจำนวนเต็มเป็นข้อความไทย
        let integerText = "";

        let numArray = integerPart.split("").map(Number);
        numArray.forEach((num, index) => {
          let unit = thaiUnits[numArray.length - index - 1];
          let digit = thaiNumbers[num];
          if (num !== 0) {
            if (num === 1 && index === numArray.length - 1) {
              // ตรวจสอบว่าเป็นตำแหน่งสุดท้าย
              integerText += "เอ็ด" + unit;
            } else if (
              num === 2 &&
              index === numArray.length - 2 &&
              numArray.length >= 2
            ) {
              integerText += "ยี่" + unit;
            } else if (
              num === 1 &&
              index === numArray.length - 2 &&
              numArray.length >= 2
            ) {
              integerText += unit;
            } else {
              integerText += digit + unit;
            }
          }
        });

        integerText = integerText + "บาท";

        let result = "";
        result = integerText + decimalText;
        this.textamount_total_en = result;
      }
    },
    async loadInvSoDataOth() {
      //data in table
      var tmp_inv_data;
      var sub_total = 0;
      var gran_total = 0;
      var sub_total_oth = 0;
      var gran_total_oth = 0;
      const res_inv_rc = await api.billing_expensegetDataPrint(this.main_id_print);

      tmp_inv_data = res_inv_rc.data;
      console.log("res_inv_rc.data:");
      console.log("");
      tmp_inv_data.forEach((item, index) => {
        var data = {
          no: 0,
          inv_id: "",
          date: null,
          credit_term: 0,
          currency: "",
          amount: 0,
          amount_s: 0,
          amount_s_ex: 0,
          amount_sub: 0,
        };
        data.no = index + 1;
        data.inv_id = item.inv_id;
        data.date = item.date_show;
        data.credit_term = item.credit_term;
        data.currency = item.currency;
        data.amount = Number(item.inv_amount_total);
        if (this.vat_type == "E") {
          data.amount_s = Number(item.inv_amount_total).toFixed(2);
        } else if (this.vat_type == "I") {
          // data.amount_s = (data.amount  inv_sub_total(data.amount * (this.vat / 100))).toFixed(2);
          data.amount_s = Number(item.inv_amount_total).toFixed(2);
        } else {
          return;
        }
        data.amount_sub = Number(item.inv_sub_total).toFixed(2);

        data.amount_s_ex = Number(data.amount_s) * this.exchange_rate;
        data.amount_s_ex = Number(data.amount_s_ex.toFixed(2));
        data.amount_s = parseFloat(data.amount_s);
        data.amount_s_ex = parseFloat(data.amount_s_ex);
        this.print_table_detail.push(data);

        this.curency_show_tb = "";
        this.curency_show_tb = item.currency;

        sub_total_oth = Number(sub_total_oth) + Number(data.amount_sub);
        gran_total_oth = Number(gran_total_oth) + Number(data.amount_s);
        gran_total = Number(gran_total) + Number(data.amount_s_ex);
      });
      sub_total_oth = sub_total_oth.toFixed(2);
      gran_total_oth = gran_total_oth.toFixed(2);
      gran_total = gran_total.toFixed(2);
      console.log("gran_total_oth");
      console.log(gran_total_oth);
      // if(this.vat_type == "E"){
      //   this.print_header.sub_total_oth = parseFloat(Number(gran_total_oth).toFixed(2));
      //   this.print_header.tax_rate_amount_oth = parseFloat(Number(this.print_header.sub_total_oth * (this.vat/100)).toFixed(2));
      //   this.print_header.amount_total_oth = parseFloat(Number(this.print_header.sub_total_oth + this.print_header.tax_rate_amount_oth).toFixed(2));

      //   this.print_header.amount_total = parseFloat(Number(this.print_header.amount_total_oth * this.exchange_rate).toFixed(2));
      //   this.print_header.sub_total = parseFloat(Number(this.print_header.sub_total_oth * this.exchange_rate).toFixed(2));
      //   this.print_header.tax_rate_amount = parseFloat(this.print_header.amount_total - this.print_header.sub_total);
      //   //
      // }else  if(this.vat_type == "I"){
      this.print_header.amount_total_oth = parseFloat(
        Number(gran_total_oth).toFixed(2),
      );
      this.print_header.sub_total_oth = parseFloat(
        Number(sub_total_oth).toFixed(2),
      );
      this.print_header.tax_rate_amount_oth = parseFloat(
        this.print_header.amount_total_oth - this.print_header.sub_total_oth,
      );

      this.print_header.amount_total = parseFloat(
        Number(this.print_header.amount_total_oth * this.exchange_rate).toFixed(
          2,
        ),
      );
      this.print_header.sub_total = parseFloat(
        Number(this.print_header.amount_total / (1 + this.vat / 100)).toFixed(
          2,
        ),
      );
      this.print_header.tax_rate_amount = parseFloat(
        this.print_header.amount_total - this.print_header.sub_total,
      );
      // }else{

      // }
      console.log("this.print_header");
      console.log(this.print_header);
      // this.print_header.amount_total_oth = parseFloat(gran_total_oth);
      // this.print_header.amount_total = parseFloat(gran_total);

      // sub_total_oth = (this.print_header.amount_total_oth / (1 + (this.vat / 100))).toFixed(2)
      // sub_total = (this.print_header.amount_total / (1 + (this.vat / 100))).toFixed(2)
      // this.print_header.sub_total_oth = parseFloat(sub_total_oth);
      // this.print_header.sub_total = parseFloat(sub_total);

      // this.print_header.tax_rate_amount_oth = parseFloat(this.print_header.amount_total_oth - sub_total_oth)
      // this.print_header.tax_rate_amount = parseFloat(this.print_header.amount_total - sub_total)

      const checker_th = /([\u0E00-\u0E7F]+)/gmu;
      let matches = this.print_header.customer_name.match(checker_th);
      // const checker_th = /([\u0E00-\u0E7F]+)/gmu;
      if (matches) {
        this.check_cus_name = false;
      } else {
        this.check_cus_name = true;
      }

      if (this.check_cus_name) {
        this.textamount_total_en = convert.toWords(
          this.print_header.amount_total.toFixed(2),
        );
        let setcheckscratch = false;
        this.textamount_total_en = this.textamount_total_en.replace(
          /\b./g,
          function (m) {
            if (m == ",") {
              return "";
            }
            if (m == "-") {
              setcheckscratch = true;
              return m;
            } else {
              if (setcheckscratch) {
                setcheckscratch = false;
                return m;
              }
              setcheckscratch = false;
              return m.toUpperCase();
            }
          },
        );
      } else {
        //start เปลี่ยนเป็นตัวอ่านไทย
        // อาเรย์สำหรับแปลงตัวเลขเป็นข้อความไทย
        var thaiNumbers = [
          "",
          "หนึ่ง",
          "สอง",
          "สาม",
          "สี่",
          "ห้า",
          "หก",
          "เจ็ด",
          "แปด",
          "เก้า",
        ];
        var thaiUnits = ["", "สิบ", "ร้อย", "พัน", "หมื่น", "แสน", "ล้าน"];

        // แยกตัวจำนวนเต็มและทศนิยมห
        this.print_header.amount_total =
          Math.round(this.print_header.amount_total * 100) / 100;
        var [
          integerPart,
          decimalPart,
        ] = this.print_header.amount_total.toString().split(".");

        // แปลงส่วนทศนิยมเป็นข้อความไทย (สตางค์)
        let de_check = 0;
        if (decimalPart) {
          if (decimalPart.split("").length == 1) {
            if (Number(decimalPart) >= 10) {
              decimalPart = decimalPart;
            } else if (Number(decimalPart) > 0) {
              decimalPart = Number(decimalPart) * 10;
            } else {
              de_check = 1;
            }
          }
        } else {
          de_check = 1;
        }

        let decimalText = "";
        if (de_check == 0) {
          decimalPart = String(decimalPart);

          var numArrays = decimalPart.split("").map(Number);
          numArrays.forEach((num, index) => {
            var units = thaiUnits[numArrays.length - index - 1];
            var digits = thaiNumbers[num];
            if (num !== 0) {
              if (num === 1 && index === numArrays.length - 1) {
                // ตรวจสอบว่าเป็นตำแหน่งสุดท้าย
                decimalText += "เอ็ด" + units;
              } else if (
                num === 2 &&
                index === numArrays.length - 2 &&
                numArrays.length >= 2
              ) {
                decimalText += "ยี่" + units;
              } else if (
                num === 1 &&
                index === numArrays.length - 2 &&
                numArrays.length >= 2
              ) {
                decimalText += units;
              } else {
                decimalText += digits + units;
              }
            }
          });

          decimalText = decimalText + "สตางค์";
        }

        // แปลงส่วนจำนวนเต็มเป็นข้อความไทย
        let integerText = "";

        var numArray = integerPart.split("").map(Number);
        numArray.forEach((num, index) => {
          var unit = thaiUnits[numArray.length - index - 1];
          var digit = thaiNumbers[num];
          if (num !== 0) {
            if (num === 1 && index === numArray.length - 1) {
              // ตรวจสอบว่าเป็นตำแหน่งสุดท้าย
              integerText += "เอ็ด" + unit;
            } else if (
              num === 2 &&
              index === numArray.length - 2 &&
              numArray.length >= 2
            ) {
              integerText += "ยี่" + unit;
            } else if (
              num === 1 &&
              index === numArray.length - 2 &&
              numArray.length >= 2
            ) {
              integerText += unit;
            } else {
              integerText += digit + unit;
            }
          }
        });

        integerText = integerText + "บาท";

        var result = "";
        result = integerText + decimalText;
        this.textamount_total_en = result;
      }
      // this.print_header.sub_total = sub_total;
    },
    async checkcontent() {
      this.datashowAll = [];
      // alert(data.length);
      this.setdatatoshow = [];
      let linedetailprpo = 23;
      let datainlineprpo = 80;
      let addnewbutget = 1;
      let getdata = [];
      let getnewdata = [];
      let hllinedetails = 0;
      this.pageAll = 1;
      let newhllinedetails = 0;
      for (let i = 0; i < this.print_table_detail.length; i++) {
        let stringchecklength = "";
        let lengthofdataforshowprpo = this.print_table_detail[i].inv_id.length;

        let maiek = "่"; //ไม้เอก
        let maito = "้"; //ไม้โท
        let maitree = "๊"; //ไม้ตรี
        let maijattawa = "๋"; //ไม้จัตวา
        let vowelei = "ิ"; //สระอิ
        let vowelee = "ี"; //สระอี
        let voweleue = "ึ"; //สระอึ
        let voweleu = "ื"; //สระอือ
        let vowelu = "ุ"; //สระอุ
        let voweluu = "ู"; //สระอู
        let maihun = "ั"; //ไม้หันอากาศ
        let maiyamok = "็"; //ไม้เอก
        newhllinedetails = 0;
        getnewdata = [];
        this.print_table_detail[i].no = i + 1;

        for (let j = 0; j < this.print_table_detail[i].inv_id.length; j++) {
          if (
            stringchecklength[j] == maiek ||
            stringchecklength[j] == maito ||
            stringchecklength[j] == maitree ||
            stringchecklength[j] == maijattawa ||
            stringchecklength[j] == vowelei ||
            stringchecklength[j] == vowelee ||
            stringchecklength[j] == voweleue ||
            stringchecklength[j] == voweleu ||
            stringchecklength[j] == vowelu ||
            stringchecklength[j] == voweluu ||
            stringchecklength[j] == maihun ||
            stringchecklength[j] == maiyamok
          ) {
            lengthofdataforshowprpo--;
          }
        }
        newhllinedetails = Math.ceil(lengthofdataforshowprpo / datainlineprpo);

        // if (this.print_table_detail[i].first_item == 1) {
        //   newhllinedetails++;
        // }

        // newhllinedetails = Math.ceil(
        //   this.print_table_detail[i].NAME.length / datainlineprpo
        // );

        // newhllinedetails += addnewbutget;
        getnewdata.push(this.print_table_detail[i]);

        if (hllinedetails + newhllinedetails > linedetailprpo) {
          this.setdatatoshow[this.pageAll - 1] = getdata;
          this.pageAll++;

          hllinedetails = 0;
          getdata = [];
          getdata.push(this.print_table_detail[i]);
          hllinedetails += newhllinedetails;
          if (i == this.print_table_detail.length - 1) {
            this.setdatatoshow[this.pageAll - 1] = getdata;
            getdata = [];
          }
        } else {
          hllinedetails += newhllinedetails;

          getdata.push(this.print_table_detail[i]);

          if (i == this.print_table_detail.length - 1) {
            this.setdatatoshow[this.pageAll - 1] = getdata;
            getdata = [];
          }
        }
      }
      this.opensummarize = true;

      this.setdatatoshow.forEach((item, iitem) => {
        if (iitem == this.setdatatoshow.length - 1) {
          item[this.setdatatoshow[iitem].length - 1].lastdata = "lastindex";
        }

        this.datashowAll.push(item);
      });
    },
    async exportToPDF() {
      // this.$refs.html2Pdf.generatePdf();

      this.showprint = "";
      let element = document.getElementById("mydivhtmltobase");
      const opt = {
        margin: [0, 0, 0, 0],
        image: {
          type: "jpeg",
          quality: 0.98,
        },
        // enableLinks: false,
        html2canvas: {
          scale: 2,
          dpi: 192,
          letterRendering: true,
          useCORS: true,
          // ignoreElements: (e) => {
          //   return e.classList.contains("cke_pagebreak") ||
          //     e.classList.contains("html2pdf__page-break")
          //     ? true
          //     : false;
          // },
        },
        jsPDF: {
          unit: "cm",
          format: "A4",
          orientation: "portrait",
          putOnlyUsedFonts: true,
          pagesplit: true,
        },
        // pagebreak: { mode: ["avoid-all"], after: ".cke_pagebreak" },
      };

      let abcd = await html2pdf()
        .from(element)
        .set(opt)
        .toPdf()
        .get("pdf")
        // .output("bloburl")
        .then(function (pdf) {
          const totalPages = pdf.internal.getNumberOfPages();
          pdf.deletePage(totalPages);
          return pdf.output("bloburl");
        });
      // console.log(abcd);
      window.open(abcd);
      let blob = await fetch(abcd).then((r) => r.blob());
      this.showprint = "display:none;";

      return;
    },
    //print summary end
    //print detail start
    async loadRef_TypeRcDetailById() {
      this.print_detail_header = {};
      const res_inv_id = await api.billing_expensegetDataReceiveDByIDOne(this.main_id_print);

      this.inv_detail_id = res_inv_id.data[0].inv_hid;
      this.tax_detail_rate = res_inv_id.data[0].tax_rate;
      this.payment_by_print = res_inv_id.data[0].payment_by;
      this.bank_name_show = res_inv_id.data[0].bank_name;
      this.bank_no_show = res_inv_id.data[0].bank_no;
      let inv_no = "";
      res_inv_id.data.forEach((item, index) => {
        if (index < res_inv_id.data.length - 1) {
          inv_no = inv_no + item.inv_id + ", ";
        } else {
          inv_no = inv_no + item.inv_id;
        }
      });

      const res_hresult = await api.billing_expense_getdataByIdInvoice_HRC(
        res_inv_id.data[0].inv_hid,
      );

      if (res_hresult.data[0].company_inv == "D") {
        this.getcompany_id = 1;
        this.print_detail_header = this.print_header_list_detail[0];
        this.checklawoffice = false;
        this.heighttabledetail = "270px";
        this.print_detail_header.com_title = "RECEIPT / TAX INVOICE";
        this.print_detail_header.com_title_th = "ใบเสร็จรับเงิน / ใบกำกับภาษี";
      } else if (res_hresult.data[0].company_inv == "L") {
        this.getcompany_id = 1;
        this.print_detail_header = this.print_header_list_detail[1];
        this.checklawoffice = true;
        this.heighttabledetail = "300px";
        this.print_detail_header.com_title = "RECEIPT";
        this.print_detail_header.com_title_th = "ใบเสร็จรับเงิน";
      } else {
        this.print_detail_header.inv_company_address2 = res_hresult.data[0].inv_company_address2;
        this.print_detail_header.inv_subdistrict = res_hresult.data[0].inv_subdistrict;
        this.print_detail_header.inv_district = res_hresult.data[0].inv_district;
        this.print_detail_header.inv_province = res_hresult.data[0].inv_province;
        this.print_detail_header.inv_postcode = res_hresult.data[0].inv_postcode;
        this.print_detail_header.inv_country = res_hresult.data[0].inv_country;

        this.getcompany_id = res_hresult.data[0].company_inv;
        this.heighttabledetail = "365px";
        this.print_detail_header.com_title = "RECEIPT / TAX INVOICE";
        this.print_detail_header.com_title_th = "ใบเสร็จรับเงิน / ใบกำกับภาษี";
        this.print_detail_header.com_name = res_hresult.data[0].com_name;
        this.print_detail_header.inv_company_address =
          res_hresult.data[0].inv_company_address;
        this.print_detail_header.inv_company_branch =
          res_hresult.data[0].inv_company_branch;
        this.print_detail_header.inv_company_tel =
          res_hresult.data[0].inv_company_tel;
        this.print_detail_header.inv_company_email =
          res_hresult.data[0].inv_company_email;
        this.print_detail_header.inv_tax_id = res_hresult.data[0].inv_tax_id;
        this.print_detail_header.inv_company_name_th =
          res_hresult.data[0].inv_company_name_th;
      }
      this.print_detail_header.company_inv = res_hresult.data[0].company_inv;
      this.print_detail_header.invoice_no = inv_no;
      if (res_inv_id.data[0].payment_by == "cash") {
        this.print_detail_header.payment_by = "Cash";
      } else if (res_inv_id.data[0].payment_by == "Bank") {
        this.print_detail_header.payment_by = "Bank Transfer";
      } else if (res_inv_id.data[0].payment_by == "cheque") {
        this.print_detail_header.payment_by = "Bank Cheque";
      }
      this.print_detail_header.payment_detail =
        res_inv_id.data[0].payment_comment;
      this.print_detail_header.inv_id = res_inv_id.data[0].trc_id;

      this.print_detail_header.invoice_date = res_hresult.data[0].date_show;

      this.print_detail_header.wth_rate = res_hresult.data[0].wth_rate;
      this.print_detail_header.tax_rate = this.tax_detail_rate;
      this.print_detail_header.wth_rate_amount = parseFloat(
        (res_hresult.data[0].sub_total * res_hresult.data[0].wth_rate) / 100,
      );
    },
    async loadMainRcData() {
      // this.print_detail_header = {};
      // var tmp_inv_data;
      const res_inv_so = await api.billing_expense_getdataByIdInvoice_HRC(this.inv_detail_id);
      if (res_inv_so.data[0].company_inv == "D") {
        this.getcompany_id = 1;
        this.print_detail_header = this.print_header_list_detail[0];
        this.print_detail_header.com_title = "RECEIPT / TAX INVOICE";
        this.print_detail_header.com_title_th = "ใบเสร็จรับเงิน / ใบกำกับภาษี";
      } else if (res_inv_so.data[0].company_inv == "L") {
        this.getcompany_id = 1;
        this.print_detail_header = this.print_header_list_detail[1];
        this.print_detail_header.com_title = "RECEIPT";
        this.print_detail_header.com_title_th = "ใบเสร็จรับเงิน";
      } else {
        this.getcompany_id = res_inv_so.data[0].company_inv;
        this.print_detail_header.com_title = "RECEIPT / TAX INVOICE";
        this.print_detail_header.com_title_th = "ใบเสร็จรับเงิน / ใบกำกับภาษี";
        this.print_detail_header.com_name = res_inv_so.data[0].com_name;
        this.print_detail_header.inv_company_address =
          res_inv_so.data[0].inv_company_address;
        this.print_detail_header.inv_company_branch =
          res_inv_so.data[0].inv_company_branch;
        this.print_detail_header.inv_company_tel =
          res_inv_so.data[0].inv_company_tel;
        this.print_detail_header.inv_company_email =
          res_inv_so.data[0].inv_company_email;
        this.print_detail_header.inv_tax_id = res_inv_so.data[0].inv_tax_id;
        this.print_detail_header.inv_company_name_th =
          res_inv_so.data[0].inv_company_name_th;
      }

      this.currency_show = res_inv_so.data[0].currency;
      this.print_detail_header.customer_name = res_inv_so.data[0].customer_name;
      // this.print_header.invoice_date = res_inv_so.data[0].date;
      this.print_detail_header.addressall = res_inv_so.data[0].addressall;
      this.print_detail_header.customer_address =
        res_inv_so.data[0].customer_address;

      this.print_detail_header.province_invoice =
        res_inv_so.data[0].province_invoice;
      this.print_detail_header.country_invoice =
        res_inv_so.data[0].country_invoice;
      this.print_detail_header.zipcode_invoice =
        res_inv_so.data[0].zipcode_invoice;

      this.print_detail_header.period_cover = res_inv_so.data[0].inv_id
        ? res_inv_so.data[0].inv_id
        : res_inv_so.data[0].pinv_id;
      this.print_detail_header.customer_contact_name =
        res_inv_so.data[0].customer_contact_name;
      this.print_detail_header.customer_taxid =
        res_inv_so.data[0].customer_taxid;
      this.branch_cus = res_inv_so.data[0].customer_branch;
      this.print_detail_header.tax_rate = this.vat;
    },
    async loadRcData() {
      //data in table
      var tmp_inv_data;
      var sub_total = 0;
      const res_inv_rc = await api.billing_expensegetDataReceiveDByID(this.main_id_print);

      tmp_inv_data = res_inv_rc.data;

      tmp_inv_data.forEach((item, index) => {
        var data = {
          description: "",
          quantity: 0,
          amount: 0,
        };

        data.description = item.inv_detail;
        data.quantity = parseFloat(item.inv_qty);
        data.amount = parseFloat(item.inv_lineamount);
        this.print_table_Rcdetail.push(data);
        sub_total = sub_total + parseFloat(item.inv_lineamount);
      });
      if (this.vat_type == "E") {
        this.print_detail_header.sub_total = parseFloat(
          Number(sub_total).toFixed(2),
        );
        this.print_detail_header.tax_rate_amount = parseFloat(
          Number(
            (this.print_detail_header.sub_total * this.tax_detail_rate) / 100,
          ).toFixed(2),
        );
        this.print_detail_header.amount_total = parseFloat(
          this.print_detail_header.sub_total +
          this.print_detail_header.tax_rate_amount,
        );
      } else if (this.vat_type == "I") {
        this.print_detail_header.amount_total = parseFloat(
          Number(sub_total).toFixed(2),
        );
        this.print_detail_header.sub_total = parseFloat(
          Number(sub_total / (1 + this.tax_detail_rate / 100)).toFixed(2),
        );
        this.print_detail_header.tax_rate_amount = parseFloat(
          this.print_detail_header.amount_total -
          this.print_detail_header.sub_total,
        );
      } else {
      }

      // this.textamount_total_en = convert.toWords(
      //   this.print_detail_header.amount_total.toFixed(2)
      // );

      //check lag
      const checker_th = /([\u0E00-\u0E7F]+)/gmu;
      let matches = this.print_detail_header.customer_name.match(checker_th);
      // const checker_th = /([\u0E00-\u0E7F]+)/gmu;
      if (matches) {
        this.check_cus_name = false;
      } else {
        this.check_cus_name = true;
      }

      if (this.check_cus_name) {
        this.textamount_total_en = convert.toWords(
          this.print_detail_header.amount_total.toFixed(2),
        );

        let setcheckscratch = false;
        this.textamount_total_en = this.textamount_total_en.replace(
          /\b./g,
          function (m) {
            if (m == ",") {
              return "";
            }
            if (m == "-") {
              setcheckscratch = true;
              return m;
            } else {
              if (setcheckscratch) {
                setcheckscratch = false;
                return m;
              }
              setcheckscratch = false;
              return m.toUpperCase();
            }
          },
        );
      } else {
        var result = "";

        //start เปลี่ยนเป็นตัวอ่านไทย
        // อาเรย์สำหรับแปลงตัวเลขเป็นข้อความไทย
        var thaiNumbers = [
          "",
          "หนึ่ง",
          "สอง",
          "สาม",
          "สี่",
          "ห้า",
          "หก",
          "เจ็ด",
          "แปด",
          "เก้า",
        ];
        var thaiUnits = ["", "สิบ", "ร้อย", "พัน", "หมื่น", "แสน", "ล้าน"];

        // แยกตัวจำนวนเต็มและทศนิยมห
        this.print_detail_header.amount_total =
          Math.round(this.print_detail_header.amount_total * 100) / 100;
        var [
          integerPart,
          decimalPart,
        ] = this.print_detail_header.amount_total.toString().split(".");

        let de_check = 0;
        if (decimalPart) {
          if (decimalPart.split("").length == 1) {
            if (Number(decimalPart) >= 10) {
              decimalPart = decimalPart;
            } else if (Number(decimalPart) > 0) {
              decimalPart = Number(decimalPart) * 10;
            } else {
              de_check = 1;
            }
          }
        } else {
          de_check = 1;
        }

        let decimalText = "";
        if (de_check == 0) {
          decimalPart = String(decimalPart);

          let numArrays = decimalPart.split("").map(Number);
          numArrays.forEach((num, index) => {
            let units = thaiUnits[numArrays.length - index - 1];
            let digits = thaiNumbers[num];
            if (num !== 0) {
              if (num === 1 && index === numArrays.length - 1) {
                // ตรวจสอบว่าเป็นตำแหน่งสุดท้าย
                decimalText += "เอ็ด" + units;
              } else if (
                num === 2 &&
                index === numArrays.length - 2 &&
                numArrays.length >= 2
              ) {
                decimalText += "ยี่" + units;
              } else if (
                num === 1 &&
                index === numArrays.length - 2 &&
                numArrays.length >= 2
              ) {
                decimalText += units;
              } else {
                decimalText += digits + units;
              }
            }
          });

          decimalText = decimalText + "สตางค์";
        }

        // แปลงส่วนจำนวนเต็มเป็นข้อความไทย
        let integerText = "";

        let numArray = integerPart.split("").map(Number);
        numArray.forEach((num, index) => {
          let unit = thaiUnits[numArray.length - index - 1];
          let digit = thaiNumbers[num];
          if (num !== 0) {
            if (num === 1 && index === numArray.length - 1) {
              // ตรวจสอบว่าเป็นตำแหน่งสุดท้าย
              integerText += "เอ็ด" + unit;
            } else if (
              num === 2 &&
              index === numArray.length - 2 &&
              numArray.length >= 2
            ) {
              integerText += "ยี่" + unit;
            } else if (
              num === 1 &&
              index === numArray.length - 2 &&
              numArray.length >= 2
            ) {
              integerText += unit;
            } else {
              integerText += digit + unit;
            }
          }
        });

        integerText = integerText + "บาท";

        result = integerText + decimalText;
        this.textamount_total_en = result;
        console.log("this.textamount_total_en: " + this.textamount_total_en);
      }
    },
    async checkcontentdetail() {
      this.datashowAllDetail = [];
      // alert(data.length);
      this.setdatatoshowDetail = [];
      let linedetailprpo = 17;
      let datainlineprpo = 50;
      let addnewbutget = 1;
      let getdata = [];
      let getnewdata = [];
      let hllinedetails = 0;
      this.pageAllDetail = 1;
      let newhllinedetails = 0;
      for (let i = 0; i < this.print_table_Rcdetail.length; i++) {
        let stringchecklength = "";
        let lengthofdataforshowprpo = this.print_table_Rcdetail[i].description
          .length;

        let maiek = "่"; //ไม้เอก
        let maito = "้"; //ไม้โท
        let maitree = "๊"; //ไม้ตรี
        let maijattawa = "๋"; //ไม้จัตวา
        let vowelei = "ิ"; //สระอิ
        let vowelee = "ี"; //สระอี
        let voweleue = "ึ"; //สระอึ
        let voweleu = "ื"; //สระอือ
        let vowelu = "ุ"; //สระอุ
        let voweluu = "ู"; //สระอู
        let maihun = "ั"; //ไม้หันอากาศ
        let maiyamok = "็"; //ไม้เอก
        newhllinedetails = 0;
        getnewdata = [];
        this.print_table_Rcdetail[i].no = i + 1;

        for (
          let j = 0;
          j < this.print_table_Rcdetail[i].description.length;
          j++
        ) {
          if (
            stringchecklength[j] == maiek ||
            stringchecklength[j] == maito ||
            stringchecklength[j] == maitree ||
            stringchecklength[j] == maijattawa ||
            stringchecklength[j] == vowelei ||
            stringchecklength[j] == vowelee ||
            stringchecklength[j] == voweleue ||
            stringchecklength[j] == voweleu ||
            stringchecklength[j] == vowelu ||
            stringchecklength[j] == voweluu ||
            stringchecklength[j] == maihun ||
            stringchecklength[j] == maiyamok
          ) {
            lengthofdataforshowprpo--;
          }
        }
        newhllinedetails = Math.ceil(lengthofdataforshowprpo / datainlineprpo);

        getnewdata.push(this.print_table_Rcdetail[i]);

        if (hllinedetails + newhllinedetails > linedetailprpo) {
          this.setdatatoshowDetail[this.pageAllDetail - 1] = getdata;
          this.pageAllDetail++;

          hllinedetails = 0;
          getdata = [];
          getdata.push(this.print_table_Rcdetail[i]);
          hllinedetails += newhllinedetails;
          if (i == this.print_table_Rcdetail.length - 1) {
            this.setdatatoshowDetail[this.pageAllDetail - 1] = getdata;
            getdata = [];
          }
        } else {
          hllinedetails += newhllinedetails;

          getdata.push(this.print_table_Rcdetail[i]);

          if (i == this.print_table_Rcdetail.length - 1) {
            this.setdatatoshowDetail[this.pageAllDetail - 1] = getdata;
            getdata = [];
          }
        }
      }
      this.opensummarizeDetail = true;

      this.setdatatoshowDetail.forEach((item, iitem) => {
        if (iitem == this.setdatatoshowDetail.length - 1) {
          item[this.setdatatoshowDetail[iitem].length - 1].lastdata =
            "lastindex";
        }

        this.datashowAllDetail.push(item);
      });
    },
    async exportToPDFDetail() {
      // this.$refs.html2Pdf.generatePdf();

      this.showprintDetail = "";
      let element = document.getElementById("mydivhtmltobaseDetail");
      const opt = {
        margin: [0, 0, 0, 0],
        image: {
          type: "jpeg",
          quality: 0.98,
        },
        // enableLinks: false,
        html2canvas: {
          scale: 2,
          dpi: 192,
          letterRendering: true,
          useCORS: true,
          // ignoreElements: (e) => {
          //   return e.classList.contains("cke_pagebreak") ||
          //     e.classList.contains("html2pdf__page-break")
          //     ? true
          //     : false;
          // },
        },
        jsPDF: {
          unit: "cm",
          format: "A4",
          orientation: "portrait",
          putOnlyUsedFonts: true,
          pagesplit: true,
        },
        // pagebreak: { mode: ["avoid-all"], after: ".cke_pagebreak" },
      };

      let abcd = await html2pdf()
        .from(element)
        .set(opt)
        .toPdf()
        .get("pdf")
        // .output("bloburl")
        .then(function (pdf) {
          const totalPages = pdf.internal.getNumberOfPages();
          pdf.deletePage(totalPages);
          return pdf.output("bloburl");
        });
      // console.log(abcd);
      window.open(abcd);
      let blob = await fetch(abcd).then((r) => r.blob());
      this.showprintDetail = "display:none;";

      return;
    },
    //print detail end
    async printReceive() {
      if (this.dialogSelect == "1") {
        // alert(this.currency_print)
        this.datashowAll = [];
        this.print_table_detail = [];
        this.dialogSelectPrint = false;
        this.$showLoader();
        await this.loadRef_TypeRcById();
        await this.loadMainInvSoData();
        if (this.currency == "THB") {
          await this.loadInvSoData();
        } else {
          await this.loadInvSoDataOth();
        }
        await this.checkcontent();
        // await this.exportToPDF();
        await this.exportReceiptToPDFMake();
        this.$hideLoader();
      } else {
        this.datashowAllDetail = [];
        this.print_table_Rcdetail = [];
        this.dialogSelectPrint = false;
        this.$showLoader();
        await this.loadRef_TypeRcDetailById();
        await this.loadMainRcData();
        await this.loadRcData();
        await this.checkcontentdetail();
        // await this.exportToPDFDetail();
        // ใช้ pdfMake สำหรับ Detail แทน html2pdf
        await this.exportReceiptDetailToPDFMake();
        this.$hideLoader();
      }
    },

    //print end
    setupAlertDialogPush(status, title, message, text_color, link) {
      this.title = title;
      this.message = message;
      this.dialogAdd = status;
      this.text_color = text_color;
      this.link = link;
    },
    setupAlertDialog(status, title, message, text_color) {
      this.title = title;
      this.message = message;
      this.dialogAdd = status;
      this.text_color = text_color;
    },
    async SumDataT() {
      let sum_data = 0;
      this.mDataArray.forEach((item) => {
        item.inv_lineamount = Number(stringcommatonumber(item.inv_lineamount));
        sum_data = sum_data + item.inv_lineamount;
        item.inv_lineamount = tolocalestringnumber(item.inv_lineamount);
      });
      if (this.vat_type == "E") {
        this.inv_subtotal = tolocalestringnumber(sum_data);
        this.wth_ratetotal = 0;
        // this.wth_ratetotal = tolocalestringnumber(Number(this.wth_rate)/100 * sum_data);
        this.tax_ratetotal = tolocalestringnumber(
          Number((this.vat / 100) * sum_data),
        );
        this.amount_total = tolocalestringnumber(
          sum_data + Number((this.vat / 100) * sum_data),
        );
        // this.amount_total = tolocalestringnumber(sum_data - (Number(this.wth_rate)/100 * sum_data) +(Number(this.vat/100 * sum_data)));
      } else if (this.vat_type == "I") {
        this.amount_total = tolocalestringnumber(sum_data);
        // this.amount_total = tolocalestringnumber(sum_data /(1+Number(this.wth_rate)/100 ));
        this.wth_ratetotal = 0;
        // this.wth_ratetotal = tolocalestringnumber(Number(sum_data - stringcommatonumber(this.amount_total)).toFixed(2));
        this.inv_subtotal = tolocalestringnumber(
          Number(
            stringcommatonumber(this.amount_total) / (1 + this.vat / 100),
          ).toFixed(2),
        );
        this.tax_ratetotal = tolocalestringnumber(
          Number(
            stringcommatonumber(this.amount_total) -
            stringcommatonumber(this.inv_subtotal),
          ).toFixed(2),
        );
      } else {
      }
    },
    async loadInvByID() {
      const res_inv = await api.billing_expense_getdataByIdInvoice_HRC(this.inv_id_by);
      this.branch = res_inv.data[0].customer_branch;
      this.payment_term = res_inv.data[0].customer_paymentterm;
      this.attention = res_inv.data[0].attention;
      this.po_no = res_inv.data[0].po_no;
      this.wth_rate = res_inv.data[0].wth_rate;
      // this.vat_type = res_inv.data[0].vat_type;
      await this.SumDataT();
    },

    async loaddataRc() {
      this.main_id = this.$route.params.id;
      const res_rc = await api.billing_expense_getDataReceiveByID(this.main_id);

      this.main_customer_id = res_rc.data[0].customer_id;
      this.payment_by = res_rc.data[0].payment_by;
      this.bank_name = res_rc.data[0].bank_name;
      this.bank_no = res_rc.data[0].bank_no;
      this.payment_comment = res_rc.data[0].payment_comment;
      this.company_trc = res_rc.data[0].company_trc;
      this.vat = res_rc.data[0].tax_rate;
      this.amoumt_t = res_rc.data[0].trc_amoumt;
      if (res_rc.data[0].trc_id != null) {
        this.showinv_rid = res_rc.data[0].trc_id;
      }
      this.exchange_rate = res_rc.data[0].exchange_rate;
      this.date_rc = new Date(res_rc.data[0].trc_date_show)
        .toISOString()
        .substr(0, 10);
    },
    async loadCustomer() {
      if (this.main_customer_id != 0) {
        const res_customer = await api.getCustomersById(this.main_customer_id);
        this.customer_data = res_customer.data;
        console.log(this.customer_data[0]);

        //set data
        this.customer_code = this.customer_data[0].cust_account;
        this.customer_name = this.customer_data[0].name;
        this.invoice_address = this.customer_data[0].address_invoice;
        this.currency = this.customer_data[0].currency;
        this.currency_print = this.customer_data[0].currency;
        this.payment_term = this.customer_data[0].payment_term;
        this.tax_id = this.customer_data[0].taxid;
        this.vat_type = this.customer_data[0].vat_type;
      }
    },
    async loaddataRc_D() {
      let inv_docref = "";
      const res_rc_detail = await api.billing_expensegetDataReceiveDByID(this.main_id);
      if (res_rc_detail.data[0].status == 2) {
        this.status_check = true;
      }
      this.desserts = res_rc_detail.data;
      this.desserts.forEach((item, index) => {
        item.inv_qty = tolocalestringnumber(item.inv_qty);
        item.inv_price = tolocalestringnumber(
          item.inv_lineamount / item.inv_qty,
        );
        item.inv_lineamount = tolocalestringnumber(item.inv_lineamount);

        if (index < this.desserts.length - 1) {
          inv_docref = inv_docref + item.inv_hid + ",";
        } else {
          inv_docref = inv_docref + item.inv_hid;
        }
      });
      this.mDataArray = this.desserts;
      const res_docRef = await api.billing_expense_getReceiveDetail("INV_REF", {
        id: inv_docref,
      });
      this.res_docRef = res_docRef.data;
      let inv_id_s = "";
      this.res_docRef.forEach((item, index) => {
        if (index < this.res_docRef.length - 1) {
          inv_id_s = inv_id_s + item.inv_id + ",";
        } else {
          inv_id_s = inv_id_s + item.inv_id;
        }
      });
      this.doc_ref = inv_id_s;
      this.inv_id_by = res_docRef.data[0].id;
    },
    async openeditItem(item) {
      this.editedIndex = this.desserts.indexOf(item);
      this.dataedit_service.inv_seq = item.inv_seq;
      this.dataedit_service.inv_detail = item.inv_detail;
      this.dataedit_service.inv_qty = stringcommatonumber(item.inv_qty);
      this.dataedit_service.inv_price = stringcommatonumber(item.inv_price);
      this.dataedit_service.inv_lineamount = item.inv_lineamount;
      this.dialogEdit = true;
    },
    async closeeditItem() {
      this.dialogEdit = false;
    },
    async calserviceamount() {
      this.dataedit_service.inv_lineamount = parseFloat(
        this.dataedit_service.inv_qty * this.dataedit_service.inv_price,
      );
      this.dataedit_service.inv_lineamount = tolocalestringnumber(
        this.dataedit_service.inv_lineamount,
      );
    },
    async saveeditItem() {
      this.desserts[
        this.editedIndex
      ].inv_detail = this.dataedit_service.inv_detail;
      this.desserts[this.editedIndex].inv_qty = tolocalestringnumber(
        this.dataedit_service.inv_qty,
      );
      this.desserts[this.editedIndex].inv_price = tolocalestringnumber(
        this.dataedit_service.inv_price,
      );
      this.desserts[
        this.editedIndex
      ].inv_lineamount = this.dataedit_service.inv_lineamount;
      this.dialogEdit = false;
      await this.SumDataT();
    },
    deleteItem(item) {
      this.editedIndex = this.desserts.indexOf(item);
      this.dialogDeleteServic = true;
    },
    closeDeleteService() {
      this.dialogDeleteServic = false;
    },
    async deleteItemConfirm() {
      this.desserts.splice(this.editedIndex, 1);
      this.desserts.forEach((item, index) => {
        if (index >= this.editedIndex) {
          item.inv_seq = item.inv_seq - 1;
        }
      });
      this.dialogDeleteServic = false;
      await this.SumDataT();
    },
    async saveinvDraft() {
      // alert(this.exchange_rate)
      if (this.exchange_rate == 0 || this.exchange_rate == "") {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Check information",
          "Please Enter Exchange Rate Data",
          "text-h5 red--text text-center",
        );
        return;
      }
      this.dataAddRc_H.trc_amoumt = Number(
        stringcommatonumber(this.amount_total),
      );
      this.dataAddRc_H.trc_sub_amoumt = Number(
        stringcommatonumber(this.inv_subtotal),
      );
      this.dataAddRc_H.exchange_rate = this.exchange_rate;
      this.dataAddRc_H.payment_by = this.payment_by;

      this.dataAddRc_H.bank_name = this.bank_name;
      this.dataAddRc_H.bank_no = this.bank_no;

      this.dataAddRc_H.payment_comment = this.payment_comment;
      this.dataAddRc_H.user_update = localStorage.getItem(server.USER_ID);
      this.dataAddRc_H.company_trc = this.company_trc;
      this.dataAddRc_H.trc_tax = Number(
        stringcommatonumber(this.tax_ratetotal),
      );
      this.dataAddRc_H.trc_date = this.date_rc;
      this.$showLoader();
      const res_updateData = await api.billing_expense_getDataReceiveByID(
        this.main_id,
        "Draft",
        this.dataAddRc_H,
      );
      if (res_updateData.status == 200 || res_updateData.status == 201) {
        await api.billing_expensedeleteReceiveD(this.main_id);
        this.desserts.forEach(async (item) => {
          this.dataAddRc_D.trc_hid = this.main_id;
          this.dataAddRc_D.inv_seq = item.inv_seq;
          this.dataAddRc_D.inv_hid = item.inv_hid;
          this.dataAddRc_D.inv_detail = item.inv_detail;
          this.dataAddRc_D.inv_qty = Number(stringcommatonumber(item.inv_qty));
          this.dataAddRc_D.inv_lineamount = Number(
            stringcommatonumber(item.inv_lineamount),
          );
          this.dataAddRc_D.user_create = Number(
            localStorage.getItem(server.USER_ID),
          );
          this.dataAddRc_D.user_update = Number(
            localStorage.getItem(server.USER_ID),
          );
          await api.billing_expenseCreateDataReceiveD(this.dataAddRc_D);
        });
        this.$hideLoader();
        this.$store.state.global_push_dialog = true;
        this.setupAlertDialogPush(
          true,
          "Information Saved",
          "Information successfully saved",
          "text-h5 green--text text-center",
          `/receive-adjsut-edit/${this.$route.params.id}`,
        );
        await this.loaddataRc();
        await this.loadCustomer();
        await this.loaddataRc_D();
        await this.loadInvByID();
      } else {
        this.$store.state.global_push_dialog = true;
        this.setupAlertDialogPush(
          true,
          "ผิดพลาด",
          "บันทึกข้อมูลไม่สำเร็จ",
          "text-h5 red--text text-center",
          "/receive",
        );
        this.$hideLoader();
      }
    },
    async saveCancel() {
      this.dialogDeleteRecevie = true;
    },
    async saveinvSubmit() {
      if (this.exchange_rate == 0 || this.exchange_rate == "") {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Check information",
          "Please Enter Exchange Rate Data",
          "text-h5 red--text text-center",
        );
        return;
      }
      if (this.mDataArray.length < 1) {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Check information",
          "Please provide the invoice details.",
          "text-h5 red--text text-center",
        );
        return;
      }
      this.dataAddRc_H.trc_amoumt = Number(
        stringcommatonumber(this.amount_total),
      );
      this.dataAddRc_H.trc_sub_amoumt = Number(
        stringcommatonumber(this.inv_subtotal),
      );

      this.dataAddRc_H.payment_by = this.payment_by;
      this.dataAddRc_H.exchange_rate = this.exchange_rate;
      this.dataAddRc_H.payment_comment = this.payment_comment;

      this.dataAddRc_H.bank_name = this.bank_name;
      this.dataAddRc_H.bank_no = this.bank_no;

      // this.dataAddRc_H.company_trc = this.company_trc;
      // this.dataAddRc_H.trc_tax = Number(stringcommatonumber(this.tax_ratetotal));
      // this.dataAddRc_H.status = 2;
      this.dataAddRc_H.user_update = localStorage.getItem(server.USER_ID);

      // this.dataAddRc_H.trc_date = this.date_rc;

      this.$showLoader();
      const res_updateData = await api.billing_expense_updateReceiveH(
        this.main_id,
        "Summit_Adjust",
        this.dataAddRc_H,
      );
      if (res_updateData.status == 200 || res_updateData.status == 201) {
        await api.billing_expensedeleteReceiveD(this.main_id);
        this.desserts.forEach(async (item) => {
          this.dataAddRc_D.trc_hid = this.main_id;
          this.dataAddRc_D.inv_seq = item.inv_seq;
          this.dataAddRc_D.inv_hid = item.inv_hid;
          this.dataAddRc_D.inv_detail = item.inv_detail;
          this.dataAddRc_D.inv_qty = Number(stringcommatonumber(item.inv_qty));
          this.dataAddRc_D.inv_lineamount = Number(
            stringcommatonumber(item.inv_lineamount),
          );
          this.dataAddRc_D.user_create = Number(
            localStorage.getItem(server.USER_ID),
          );
          this.dataAddRc_D.user_update = Number(
            localStorage.getItem(server.USER_ID),
          );
          await api.billing_expenseCreateDataReceiveD(this.dataAddRc_D);
        });
        this.$hideLoader();
        this.$store.state.global_push_dialog = true;
        this.setupAlertDialogPush(
          true,
          "Information Saved",
          "Information successfully saved",
          "text-h5 green--text text-center",
          `/reloadpage`,
        );
        // await this.loaddataRc();
        // await this.loadCustomer();
        // await this.loaddataRc_D();
        // await this.loadInvByID();
      } else {
        this.$store.state.global_push_dialog = true;
        this.setupAlertDialogPush(
          true,
          "ผิดพลาด",
          "บันทึกข้อมูลไม่สำเร็จ",
          "text-h5 red--text text-center",
          "/receive",
        );
        this.$hideLoader();
      }
    },
    async deleteReceive() {
      this.dialogDeleteRecevie = true;
    },
    closeDeleteRecive() {
      this.dialogDeleteRecevie = false;
    },
    async deleteReceiveConfirm() {
      this.dialogDeleteRecevie = false;

      let dataEdit = { status: 0 };
      dataEdit.status = 3;

      this.$showLoader();
      const res_update = await api.billing_expense_updateAdjustReceiveH(
        Number(this.main_id),
        dataEdit,
      );
      if (res_update.status == 200 || res_update.status == 201) {
        this.$hideLoader();
        this.$store.state.global_push_dialog = true;
        this.setupAlertDialogPush(
          true,
          "Information Saved",
          "Information successfully saved",
          "text-h5 green--text text-center",
          `/adjust-receipt`,
        );
      } else {
        this.$hideLoader();
        this.$store.state.global_push_dialog = true;
        this.setupAlertDialogPush(
          true,
          "ผิดพลาด",
          "บันทึกข้อมูลไม่สำเร็จ",
          "text-h5 red--text text-center",
          "/receive",
        );
      }
      // console.log("res_update")
      // console.log(res_update)
    },
    async onSelectvat_type() { },

    waitForPdfMakeReady() {
      return new Promise((resolve, reject) => {
        const checkInterval = setInterval(() => {
          if (typeof pdfMake !== "undefined" && pdfMake.vfs && pdfMake.fonts) {
            clearInterval(checkInterval);
            console.log("✅ pdfMake พร้อมใช้งาน พร้อมฟอนต์ภาษาไทย");
            resolve(true);
          }
        }, 100);

        setTimeout(() => {
          clearInterval(checkInterval);
          reject(new Error("pdfMake โหลดไม่สำเร็จ"));
        }, 10000);
      });
    },

    formatNumber(value) {
      if (!value && value !== 0) return "0.00";
      return new Intl.NumberFormat("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(value);
    },

    formatDate(dateString) {
      if (!dateString) return "";
      if (dateString.includes("/")) {
        return dateString;
      }

      const date = new Date(dateString);
      const day = date
        .getDate()
        .toString()
        .padStart(2, "0");
      const month = (date.getMonth() + 1).toString().padStart(2, "0");
      const year = date.getFullYear();
      return `${day}/${month}/${year}`;
    },

    createHeader() {
      return {
        columns: [
          {
            width: "50%",
            stack: [
              {
                text: this.header.com_eng_1 || "DEJ-UDOM & ASSOCIATES LTD.",
                fontSize: 11,
                bold: true,
                margin: [0, 0, 0, 1],
              },
              {
                text: this.header.com_eng_2 || "ATTORNEY AT LAW",
                fontSize: 8,
                bold: true,
                margin: [0, 0, 0, 1],
              },
              {
                text:
                  this.header.com_thai ||
                  "บริษัท เดชอุดม แอนด์ แอสโซซิเอทส์ จำกัด",
                fontSize: 8,
                margin: [0, 0, 0, 1],
              },
            ],
          },
          {
            width: "50%",
            stack: [
              {
                text:
                  this.header.com_add_name ||
                  "CHARN ISSARA TOWER 1, 2nd FLOOR,",
                fontSize: 7,
                alignment: "right",
                margin: [0, 0, 0, 1],
              },
              {
                text: this.header.com_add_no || "942/69 RAMA IV ROAD,",
                fontSize: 7,
                alignment: "right",
                margin: [0, 0, 0, 1],
              },
              {
                text:
                  this.header.com_add_city ||
                  "KWAENG SURIYAWONG, KHET BANGRAK,",
                fontSize: 7,
                alignment: "right",
                margin: [0, 0, 0, 1],
              },
              {
                text: this.header.com_add_country || "BANGKOK 10500, THAILAND",
                fontSize: 7,
                alignment: "right",
                margin: [0, 0, 0, 1],
              },
              {
                text:
                  this.header.com_add_tel || "Tel : 0-2233-0055, 0-2233-0068",
                fontSize: 7,
                alignment: "right",
                margin: [0, 0, 0, 1],
              },
              {
                text:
                  this.header.com_add_email || "E-MAIL : account@dejudom.com",
                fontSize: 7,
                alignment: "right",
                margin: [0, 0, 0, 1],
              },
              {
                text:
                  this.header.com_add_tax_id ||
                  'TAX ID. No. 0105534015348 / "HEAD OFFICE"',
                fontSize: 7,
                alignment: "right",
                bold: true,
              },
            ],
          },
        ],
        margin: [0, 0, 0, 10],
      };
    },

    createTitle() {
      return {
        stack: [
          {
            text: this.header.com_title || "RECEIPT / TAX INVOICE",
            fontSize: 14,
            bold: true,
            alignment: "center",
            margin: [0, 15, 0, 2],
          },
          {
            text: this.header.com_title_th || "ใบเสร็จรับเงิน / ใบกำกับภาษี",
            fontSize: 12,
            bold: true,
            alignment: "center",
            margin: [0, 0, 0, 10],
          },
          {
            canvas: [
              {
                type: "line",
                x1: 0,
                y1: 0,
                x2: 515,
                y2: 0,
                lineWidth: 1,
              },
            ],
            margin: [0, 0, 0, 10],
          },
        ],
      };
    },

    createCustomerInfo() {
      const addressLines = (this.header.addressall || "").split("\n");
      const filteredAddress = addressLines
        .filter((line) => line.trim() !== "" && line.trim() !== ",")
        .join(", ");

      // สร้าง array สำหรับข้อมูลด้านขวา
      const rightColumnStack = [
        {
          text: `No. / เลขที่ : ${this.header.inv_id || "________"}`,
          fontSize: 9,
          alignment: "right",
          margin: [0, 0, 0, 5],
        },
        {
          text: `Date / วันที่ : ${this.formatDate(this.header.invoice_date) ||
            "______________"}`,
          fontSize: 9,
          alignment: "right",
          margin: [0, 0, 0, 5],
        },
      ];

      // เพิ่ม Exchange Rate เฉพาะเมื่อไม่ใช่ THB
      if (this.currency_print !== "THB") {
        rightColumnStack.push({
          text: `Exchange Rate : ${this.exchangeRate || "______________"}`,
          fontSize: 9,
          alignment: "right",
        });
      }

      return {
        columns: [
          {
            width: "70%",
            stack: [
              {
                columns: [
                  {
                    width: 60,
                    text: "To / ถึง:",
                    fontSize: 9,
                  },
                  {
                    width: "*",
                    text: this.header.customer_name || "Customer Name",
                    fontSize: 9,
                    bold: true,
                  },
                ],
                margin: [0, 0, 0, 3],
              },
              {
                columns: [
                  {
                    width: 60,
                    text: "",
                    fontSize: 8,
                  },
                  {
                    width: "*",
                    text:
                      filteredAddress ||
                      "Address Line 1, address line 1, address line 1,\nAddress Line 2, address line 2, address line 2, address line 2\nAddress Line 3, address line 3, address line 3, address line 3\nCity, Postcode, COUNTRY",
                    fontSize: 8,
                  },
                ],
                margin: [0, 0, 0, 3],
              },
              {
                columns: [
                  {
                    width: 60,
                    text: "Tax ID:",
                    fontSize: 9,
                  },
                  {
                    width: "*",
                    text: this.header.customer_taxid || "__________________",
                    fontSize: 9,
                  },
                ],
              },
            ],
          },
          {
            width: "30%",
            stack: rightColumnStack, // ใช้ array ที่สร้างไว้
          },
        ],
        margin: [0, 0, 0, 10],
      };
    },

    createItemsTable() {
      const tableWidths = this.showCurrencyColumn
        ? [35, "*", 70, 80, 80]
        : [35, "*", 70, 80];

      const headerRow = [
        {
          text: "No.",
          fontSize: 9,
          bold: true,
          alignment: "center",
          margin: [2, 3, 2, 3],
        },
        {
          text: "Statement No./ เลขที่ใบเเจ้งหนี้",
          fontSize: 9,
          bold: true,
          alignment: "center",
          margin: [2, 3, 2, 3],
        },
        {
          text: "Date / วันที่",
          fontSize: 9,
          bold: true,
          alignment: "center",
          margin: [2, 3, 2, 3],
        },
      ];

      if (this.showCurrencyColumn) {
        headerRow.push({
          text: "Currency / Amount",
          fontSize: 9,
          bold: true,
          alignment: "center",
          margin: [2, 3, 2, 3],
        });
      }

      headerRow.push({
        text: "Amount / จำนวนเงิน",
        fontSize: 9,
        bold: true,
        alignment: "center",
        margin: [2, 3, 2, 3],
      });

      const bodyRows = [];
      const minRows = 7;

      for (let i = 0; i < minRows; i++) {
        if (i < this.items.length) {
          const item = this.items[i];
          console.log(`item tavle : ${JSON.stringify(item)}`);

          const row = [
            {
              text: item.no || "",
              fontSize: 9,
              alignment: "center",
              margin: [2, 3, 2, 3],
            },
            {
              text: item.inv_id || "",
              fontSize: 9,
              margin: [2, 3, 2, 3],
            },
            {
              text: this.formatDate(item.date) || "",
              fontSize: 9,
              alignment: "center",
              margin: [2, 3, 2, 3],
            },
          ];

          if (this.showCurrencyColumn) {
            row.push({
              text: item.amount ? this.formatNumber(item.amount) : "",
              fontSize: 9,
              alignment: "right",
              margin: [2, 3, 2, 3],
            });
          }

          row.push({
            text: item.amount_s ? this.formatNumber(item.amount_s) : "",
            fontSize: 9,
            alignment: "right",
            margin: [2, 3, 2, 3],
          });

          bodyRows.push(row);
        } else {
          const emptyRow = [
            {
              text: "",
              fontSize: 9,
              margin: [2, 15, 2, 15],
            },
            {
              text: "",
              fontSize: 9,
              margin: [2, 15, 2, 15],
            },
            {
              text: "",
              fontSize: 9,
              margin: [2, 15, 2, 15],
            },
          ];

          if (this.showCurrencyColumn) {
            emptyRow.push({
              text: "",
              fontSize: 9,
              margin: [2, 15, 2, 15],
            });
          }

          emptyRow.push({
            text: "",
            fontSize: 9,
            margin: [2, 15, 2, 15],
          });
          bodyRows.push(emptyRow);
        }
      }

      return {
        table: {
          headerRows: 1,
          widths: tableWidths,
          body: [headerRow, ...bodyRows],
        },
        layout: {
          hLineWidth: function (i, node) {
            // if (i === 0 || i === 1 || i === node.table.body.length) {
            if (i === 0 || i === 1) {
              return 1;
            }
            return 0;
          },
          vLineWidth: function (i) {
            return 1;
          },
          paddingLeft: function () {
            return 0;
          },
          paddingRight: function () {
            return 0;
          },
          paddingTop: function () {
            return 0;
          },
          paddingBottom: function () {
            return 0;
          },
        },
        margin: [0, 0, 0, 0],
      };
    },

    createSummaryTable() {
      const subTotal = this.header.sub_total || 0;
      const subTotalOth = this.header.sub_total_oth || 0;
      const taxRate = this.header.tax_rate || "7.00";
      const taxAmount = this.header.tax_rate_amount || 0;
      const taxAmountOth = this.header.tax_rate_amount_oth || 0;
      const grandTotal = this.header.amount_total || 0;
      const grandTotalOth = this.header.amount_total_oth || 0;
      let currency = this.currencyPrint || "USD";
      currency = currency.replace("US", "USD");
      currency = currency.replace("USDD", "USD");

      const summaryWidths = this.showCurrencyColumn
        ? [35, "*", 70, 80, 80]
        : [35, "*", 70, 80];

      const summaryRows = [];

      const subTotalRow = [
        {
          text: "Sub Total / รวมเป็นเงิน",
          fontSize: 9,
          bold: true,
          alignment: "left",
          margin: [2, 3, 2, 3],
          colSpan: 3,
        },
        { text: "" },
        { text: "" },
      ];

      if (this.showCurrencyColumn) {
        subTotalRow.push({
          text: `${currency} ${this.formatNumber(subTotalOth)}`,
          fontSize: 9,
          alignment: "right",
          margin: [2, 3, 2, 3],
        });
      }

      subTotalRow.push({
        text: this.formatNumber(subTotal),
        fontSize: 9,
        alignment: "right",
        margin: [2, 3, 2, 3],
      });

      summaryRows.push(subTotalRow);

      const vatRow = [
        {
          text: `Value Added Tax / ภาษีมูลค่าเพิ่ม (${taxRate} %)`,
          fontSize: 9,
          bold: true,
          alignment: "left",
          margin: [2, 3, 2, 3],
          colSpan: 3,
        },
        { text: "" },
        { text: "" },
      ];

      if (this.showCurrencyColumn) {
        vatRow.push({
          text: `${currency} ${this.formatNumber(taxAmountOth)}`,
          fontSize: 9,
          alignment: "right",
          margin: [2, 3, 2, 3],
        });
      }

      vatRow.push({
        text: this.formatNumber(taxAmount),
        fontSize: 9,
        alignment: "right",
        margin: [2, 3, 2, 3],
      });

      summaryRows.push(vatRow);

      const grandTotalRow = [
        {
          text: "Grand Total / ยอดรวม",
          fontSize: 9,
          bold: true,
          alignment: "left",
          margin: [2, 3, 2, 3],
          colSpan: 3,
        },
        { text: "" },
        { text: "" },
      ];

      if (this.showCurrencyColumn) {
        grandTotalRow.push({
          text: `${currency} ${this.formatNumber(grandTotalOth)}`,
          fontSize: 9,
          bold: true,
          alignment: "right",
          margin: [2, 3, 2, 3],
        });
      }

      grandTotalRow.push({
        text: this.formatNumber(grandTotal),
        fontSize: 9,
        bold: true,
        alignment: "right",
        margin: [2, 3, 2, 3],
      });

      summaryRows.push(grandTotalRow);

      return {
        table: {
          widths: summaryWidths,
          body: summaryRows,
        },
        layout: {
          hLineWidth: function (i, node) {
            return 1;
          },
          vLineWidth: function (i) {
            return 1;
          },
          hLineColor: function () {
            return "black";
          },
          vLineColor: function () {
            return "black";
          },
          paddingLeft: function () {
            return 0;
          },
          paddingRight: function () {
            return 0;
          },
          paddingTop: function () {
            return 0;
          },
          paddingBottom: function () {
            return 0;
          },
        },
        margin: [0, 0, 0, 0],
      };
    },

    createAmountInWords() {
      const amountText = this.dataToUse.textamount_total_en || "";

      // ตรวจสอบภาษาของ customer_name
      const checker_th = /([\u0E00-\u0E7F]+)/gmu;
      const isThaiCustomer = checker_th.test(this.header.customer_name || "");

      // กำหนดข้อความจำนวนเงินตัวอักษรตามภาษา
      let displayText = "";
      if (isThaiCustomer) {
        // ถ้าชื่อลูกค้าเป็นภาษาไทย → แสดงจำนวนเงินเป็นภาษาไทยโดยไม่มีวงเล็บและ currency
        displayText = `${amountText} `;
      } else {
        // ถ้าชื่อลูกค้าเป็นภาษาอังกฤษ → แสดงจำนวนเงินเป็นภาษาอังกฤษพร้อมวงเล็บและ currency
        displayText = `(${amountText}) ${this.currencyPrint || "USD"}`;
        displayText = displayText.replace("US", "USD");
        displayText = displayText.replace("USDD", "USD");
      }

      const widths = this.showCurrencyColumn
        ? [35, "*", 70, 80, 80]
        : [35, "*", 70, 80];

      const cells = [
        {
          text: displayText, // ← ใช้ displayText แทน
          fontSize: 9,
          alignment: "center",
          margin: [5, 8, 5, 8],
          fillColor: "#d8d8d8",
          colSpan: this.showCurrencyColumn ? 5 : 4,
        },
        {},
      ];

      const emptyCellCount = this.showCurrencyColumn ? 3 : 2;
      for (let i = 0; i < emptyCellCount; i++) {
        cells.push({});
      }

      return {
        table: {
          widths: widths,
          body: [cells],
        },
        layout: {
          hLineWidth: function () {
            return 0;
          },
          vLineWidth: function () {
            return 1;
          },
          hLineColor: function () {
            return "black";
          },
          vLineColor: function () {
            return "black";
          },
          paddingLeft: function () {
            return 0;
          },
          paddingRight: function () {
            return 0;
          },
          paddingTop: function () {
            return 0;
          },
          paddingBottom: function () {
            return 0;
          },
        },
        margin: [0, 0, 0, 0],
      };
    },

    createPaymentConditions() {
      const paymentDetail = this.dataToUse.payment_by_print || "";

      return {
        table: {
          widths: ["*"],
          body: [
            [
              {
                stack: [
                  {
                    text: "Payment Conditions:",
                    fontSize: 9,
                    bold: true,
                    margin: [2, 5, 2, 3],
                  },
                  {
                    columns: [
                      {
                        width: "25%",
                        text: "☐ Cash/เงินสด",
                        fontSize: 9,
                        margin: [10, 0, 0, 0],
                      },
                      {
                        width: "25%",
                        text: "☐ Transfer/โอนเงิน",
                        fontSize: 9,
                      },
                      {
                        width: "30%",
                        text: "☐ Cheque/เช็คธนาคาร",
                        fontSize: 9,
                      },
                      {
                        width: "20%",
                        text: "No./เลขที่",
                        fontSize: 9,
                      },
                    ],
                    margin: [2, 3, 2, 5],
                  },
                ],
                margin: [2, 0, 2, 0],
              },
            ],
            [
              {
                text: `Payment Details / รายละเอียด:${paymentDetail ? "  " + paymentDetail : ""
                  }`,
                fontSize: 9,
                margin: [2, 5, 2, 20],
              },
            ],
          ],
        },
        layout: {
          hLineWidth: function (i, node) {
            if (i === 0 || i === node.table.body.length) {
              return 1;
            }
            return 0;
          },
          vLineWidth: function () {
            return 1;
          },
          hLineColor: function () {
            return "black";
          },
          vLineColor: function () {
            return "black";
          },
          paddingLeft: function () {
            return 0;
          },
          paddingRight: function () {
            return 0;
          },
          paddingTop: function () {
            return 0;
          },
          paddingBottom: function () {
            return 0;
          },
        },
        margin: [0, 0, 0, 15],
      };
    },

    createSignatureBox() {
      return {
        columns: [
          {
            width: "50%",
            text: "",
          },
          {
            width: "50%",
            table: {
              widths: ["*"],
              body: [
                [
                  {
                    stack: [
                      {
                        text: "",
                        margin: [0, 0, 0, 35],
                      },
                      {
                        canvas: [
                          {
                            type: "line",
                            x1: 30,
                            y1: 0,
                            x2: 200,
                            y2: 0,
                            lineWidth: 1,
                          },
                        ],
                        margin: [0, 0, 0, 5],
                      },
                      {
                        text: "Authorized Signature / ผู้รับเงิน",
                        fontSize: 9,
                        alignment: "center",
                        margin: [0, 0, 0, 10],
                      },
                      {
                        text: "Date/วันที่ _______________________",
                        fontSize: 9,
                        alignment: "center",
                        margin: [0, 0, 0, 10],
                      },
                    ],
                  },
                ],
              ],
            },
            layout: {
              hLineWidth: function () {
                return 1;
              },
              vLineWidth: function () {
                return 1;
              },
              hLineColor: function () {
                return "black";
              },
              vLineColor: function () {
                return "black";
              },
            },
          },
        ],
        margin: [0, 0, 0, 15],
      };
    },

    createFooterNote() {
      return {
        stack: [
          {
            text:
              "This receipt will be valid whgn the company has received the payment into the bank account.",
            fontSize: 8,
            alignment: "center",
            margin: [0, 5, 0, 0],
          },
          {
            text:
              "ใบเสร็จรับเงินนี้จะสมบูรณ์เมื่อบริษัทได้รับชำระเงินเข้าในบัญชีธนาคารเรียบร้อยแล้ว",
            fontSize: 8,
            alignment: "center",
          },
        ],
        margin: [0, 10, 0, 0],
      };
    },

    generateMainReceipt() {
      const mainContent = [];
      mainContent.push(this.createHeader());
      mainContent.push(this.createTitle());
      mainContent.push(this.createCustomerInfo());
      mainContent.push(this.createItemsTable());
      mainContent.push(this.createSummaryTable());
      mainContent.push(this.createAmountInWords());
      mainContent.push(this.createPaymentConditions());
      mainContent.push(this.createSignatureBox());
      mainContent.push(this.createFooterNote());
      return mainContent;
    },

    generateDocDefinition() {
      const mainReceipt = this.generateMainReceipt();
      const docDefinition = {
        pageSize: "A4",
        pageMargins: [40, 40, 40, 40],
        content: mainReceipt,
        defaultStyle: {
          font: "Sarabun",
          fontSize: 10,
        },
      };
      return docDefinition;
    },

    async exportReceiptToPDFMake() {
      // สร้างข้อมูลแล้วโยนเข้า mockData
      // this.mockData.main_data = {
      //   datashowAll: this.datashowAll,
      //   print_header: this.print_header,
      //   heighttabledetail: this.heighttabledetail,
      //   currency_print: this.currency_print,
      //   check_cus_name: this.check_cus_name,
      //   textamount_total_en: this.textamount_total_en,
      //   checklawoffice: this.checklawoffice,
      //   exchange_rate: this.exchange_rate,
      //   branch_cus: this.branch_cus,
      //   payment_by_print: this.payment_by_print,
      //   bank_name_show: this.bank_name_show,
      //   bank_no_show: this.bank_no_show,
      // };

      // try {
      //   await this.waitForPdfMakeReady();
      // } catch (error) {
      //   console.error("❌ pdfMake ไม่พร้อมใช้งาน:", error);
      //   alert("ไม่สามารถโหลดระบบ PDF ได้ กรุณาลองใหม่อีกครั้ง");
      //   return;
      // }

      // try {
      //   const docDefinition = this.generateDocDefinition();
      //   pdfMake.createPdf(docDefinition).open();
      //   console.log("✅ สร้าง Receipt PDF สำเร็จ");
      // } catch (error) {
      //   console.error("❌ เกิดข้อผิดพลาดในการสร้าง PDF:", error);
      //   alert("เกิดข้อผิดพลาดในการสร้าง PDF: " + error.message);
      // }

      const receiptData = {
        datashowAll: this.datashowAll,
        print_header: this.print_header,
        heighttabledetail: this.heighttabledetail,
        currency_print: this.currency_print,
        check_cus_name: this.check_cus_name,
        textamount_total_en: this.textamount_total_en,
        checklawoffice: this.checklawoffice,
        exchange_rate: this.exchange_rate,
        branch_cus: this.branch_cus,
        payment_by_print: this.payment_by_print,
        bank_name_show: this.bank_name_show,
        bank_no_show: this.bank_no_show,
      };

      try {
        await generateReceiptPDF(receiptData);
      } catch (error) {
        alert("เกิดข้อผิดพลาดในการสร้าง PDF: " + error.message);
      }
    },

    createItemsTableDetail() {
      const tableWidths = ["*", 70, 80]; // 3 คอลัมน์: Description, Quantity, Amount

      const headerRow = [
        {
          text: "Description / รายการ",
          fontSize: 9,
          bold: true,
          alignment: "center",
          margin: [2, 3, 2, 3],
        },
        {
          text: "Quantity / จำนวน",
          fontSize: 9,
          bold: true,
          alignment: "center",
          margin: [2, 3, 2, 3],
        },
        {
          text: "Amount / จำนวนเงิน",
          fontSize: 9,
          bold: true,
          alignment: "center",
          margin: [2, 3, 2, 3],
        },
      ];

      const bodyRows = [];
      const minRows = 7;

      const detailItems = this.print_table_Rcdetail || [];

      for (let i = 0; i < minRows; i++) {
        if (i < detailItems.length) {
          const item = detailItems[i];
          console.log(`Detail item ${i}:`, JSON.stringify(item));

          const row = [
            {
              text: item.description || "",
              fontSize: 9,
              margin: [2, 3, 2, 3],
            },
            {
              text: item.quantity ? this.formatNumber(item.quantity) : "",
              fontSize: 9,
              alignment: "center",
              margin: [2, 3, 2, 3],
            },
            {
              text: item.amount ? this.formatNumber(item.amount) : "",
              fontSize: 9,
              alignment: "right",
              margin: [2, 3, 2, 3],
            },
          ];

          bodyRows.push(row);
        } else {
          const emptyRow = [
            {
              text: "",
              fontSize: 9,
              margin: [2, 15, 2, 15],
            },
            {
              text: "",
              fontSize: 9,
              margin: [2, 15, 2, 15],
            },
            {
              text: "",
              fontSize: 9,
              margin: [2, 15, 2, 15],
            },
          ];
          bodyRows.push(emptyRow);
        }
      }

      return {
        table: {
          headerRows: 1,
          widths: tableWidths,
          body: [headerRow, ...bodyRows],
        },
        layout: {
          hLineWidth: function (i, node) {
            if (i === 0 || i === 1 || i === node.table.body.length) {
              return 1;
            }
            return 0;
          },
          vLineWidth: function (i) {
            return 1;
          },
          paddingLeft: function () {
            return 0;
          },
          paddingRight: function () {
            return 0;
          },
          paddingTop: function () {
            return 0;
          },
          paddingBottom: function () {
            return 0;
          },
        },
        margin: [0, 0, 0, 0],
      };
    },

    createHeaderDetail() {
      const header = this.print_detail_header || {}; // ใช้ print_detail_header แทน

      return {
        columns: [
          {
            width: "50%",
            stack: [
              {
                text: header.com_eng_1 || "DEJ-UDOM & ASSOCIATES LTD.",
                fontSize: 11,
                bold: true,
                margin: [0, 0, 0, 1],
              },
              {
                text: header.com_eng_2 || "ATTORNEY AT LAW",
                fontSize: 8,
                bold: true,
                margin: [0, 0, 0, 1],
              },
              {
                text:
                  header.com_thai || "บริษัท เดชอุดม แอนด์ แอสโซซิเอทส์ จำกัด",
                fontSize: 8,
                margin: [0, 0, 0, 1],
              },
            ],
          },
          {
            width: "50%",
            stack: [
              {
                text: header.com_add_name || "CHARN ISSARA TOWER 1, 2nd FLOOR,",
                fontSize: 7,
                alignment: "right",
                margin: [0, 0, 0, 1],
              },
              {
                text: header.com_add_no || "942/69 RAMA IV ROAD,",
                fontSize: 7,
                alignment: "right",
                margin: [0, 0, 0, 1],
              },
              {
                text:
                  header.com_add_city ||
                  "KWAENG SURIYAWONG, KHET BANGRAK, BANGKOK 10500, THAILAND",
                fontSize: 7,
                alignment: "right",
                margin: [0, 0, 0, 1],
              },
              {
                text: header.com_add_tel || "Tel : 0-2233-0055, 0-2233-0068",
                fontSize: 7,
                alignment: "right",
                margin: [0, 0, 0, 1],
              },
              {
                text: header.com_add_email || "E-MAIL : account@dejudom.com",
                fontSize: 7,
                alignment: "right",
                margin: [0, 0, 0, 1],
              },
              {
                text:
                  header.com_add_tax_id ||
                  'TAX ID. No. 0105534015348 / "HEAD OFFICE"',
                fontSize: 7,
                alignment: "right",
                bold: true,
              },
            ],
          },
        ],
        margin: [0, 0, 0, 10],
      };
    },

    createTitleDetail() {
      const header = this.print_detail_header || {};

      return {
        stack: [
          {
            text: header.com_title || "RECEIPT / TAX INVOICE",
            fontSize: 14,
            bold: true,
            alignment: "center",
            margin: [0, 15, 0, 2],
          },
          {
            text: header.com_title_th || "ใบเสร็จรับเงิน / ใบกำกับภาษี",
            fontSize: 12,
            bold: true,
            alignment: "center",
            margin: [0, 0, 0, 10],
          },
          {
            canvas: [
              {
                type: "line",
                x1: 0,
                y1: 0,
                x2: 515,
                y2: 0,
                lineWidth: 1,
              },
            ],
            margin: [0, 0, 0, 10],
          },
        ],
      };
    },

    createCustomerInfoDetail() {
      const header = this.print_detail_header || {};
      const addressLines = (header.addressall || "").split("\n");
      const filteredAddress = addressLines
        .filter((line) => line.trim() !== "" && line.trim() !== ",")
        .join(", ");

      const rightColumnStack = [
        {
          text: `No. / เลขที่ : ${header.inv_id || "________"}`,
          fontSize: 9,
          alignment: "right",
          margin: [0, 0, 0, 5],
        },
        {
          text: `Date / วันที่ : ${this.formatDate(header.invoice_date) ||
            "______________"}`,
          fontSize: 9,
          alignment: "right",
          margin: [0, 0, 0, 5],
        },
      ];

      if (this.currency_print !== "THB") {
        rightColumnStack.push({
          text: `Exchange Rate : ${this.exchange_rate || "______________"}`,
          fontSize: 9,
          alignment: "right",
        });
      }

      return {
        columns: [
          {
            width: "70%",
            stack: [
              {
                columns: [
                  {
                    width: 60,
                    text: "To / ถึง:",
                    fontSize: 9,
                  },
                  {
                    width: "*",
                    text: header.customer_name || "Customer Name",
                    fontSize: 9,
                    bold: true,
                  },
                ],
                margin: [0, 0, 0, 3],
              },
              {
                columns: [
                  {
                    width: 60,
                    text: "",
                    fontSize: 8,
                  },
                  {
                    width: "*",
                    text: filteredAddress || "Address",
                    fontSize: 8,
                  },
                ],
                margin: [0, 0, 0, 3],
              },
              {
                columns: [
                  {
                    width: 60,
                    text: "Tax ID:",
                    fontSize: 9,
                  },
                  {
                    width: "*",
                    text: header.customer_taxid || "__________________",
                    fontSize: 9,
                  },
                ],
              },
            ],
          },
          {
            width: "30%",
            stack: rightColumnStack,
          },
        ],
        margin: [0, 0, 0, 10],
      };
    },

    createSummaryTableDetail() {
      const header = this.print_detail_header || {};
      const subTotal = header.sub_total || 0;
      const taxRate = header.tax_rate || "7.00";
      const taxAmount = header.tax_rate_amount || 0;
      const grandTotal = header.amount_total || 0;

      const summaryWidths = ["*", 70, 80]; // เปลี่ยนเป็น 3 คอลัมน์

      const summaryRows = [];

      const subTotalRow = [
        {
          text: "Sub Total / รวมเป็นเงิน",
          fontSize: 9,
          bold: true,
          alignment: "left",
          margin: [2, 3, 2, 3],
          colSpan: 2, // เปลี่ยนจาก 3 เป็น 2
        },
        { text: "" },
        {
          text: this.formatNumber(subTotal),
          fontSize: 9,
          alignment: "right",
          margin: [2, 3, 2, 3],
        },
      ];

      summaryRows.push(subTotalRow);

      const vatRow = [
        {
          text: `Value Added Tax / ภาษีมูลค่าเพิ่ม (${taxRate} %)`,
          fontSize: 9,
          bold: true,
          alignment: "left",
          margin: [2, 3, 2, 3],
          colSpan: 2, // เปลี่ยนจาก 3 เป็น 2
        },
        { text: "" },
        {
          text: this.formatNumber(taxAmount),
          fontSize: 9,
          alignment: "right",
          margin: [2, 3, 2, 3],
        },
      ];

      summaryRows.push(vatRow);

      const grandTotalRow = [
        {
          text: "Grand Total / ยอดรวม",
          fontSize: 9,
          bold: true,
          alignment: "left",
          margin: [2, 3, 2, 3],
          colSpan: 2, // เปลี่ยนจาก 3 เป็น 2
        },
        { text: "" },
        {
          text: this.formatNumber(grandTotal),
          fontSize: 9,
          bold: true,
          alignment: "right",
          margin: [2, 3, 2, 3],
        },
      ];

      summaryRows.push(grandTotalRow);

      return {
        table: {
          widths: summaryWidths,
          body: summaryRows,
        },
        layout: {
          hLineWidth: function (i, node) {
            return 1;
          },
          vLineWidth: function (i) {
            return 1;
          },
          hLineColor: function () {
            return "black";
          },
          vLineColor: function () {
            return "black";
          },
          paddingLeft: function () {
            return 0;
          },
          paddingRight: function () {
            return 0;
          },
          paddingTop: function () {
            return 0;
          },
          paddingBottom: function () {
            return 0;
          },
        },
        margin: [0, 0, 0, 0],
      };
    },

    createAmountInWordsDetail() {
      const amountText = this.textamount_total_en || "";
      const header = this.print_detail_header || {};

      const checker_th = /([\u0E00-\u0E7F]+)/gmu;
      const isThaiCustomer = checker_th.test(header.customer_name || "");

      let displayText = "";
      if (isThaiCustomer) {
        displayText = `${amountText}`;
      } else {
        displayText = `(${amountText}) ${this.currencyPrint || "USD"}`;
        displayText = displayText.replace("US", "USD");
        displayText = displayText.replace("USDD", "USD");
      }

      const widths = ["*", 70, 80]; // เปลี่ยนเป็น 3 คอลัมน์

      const cells = [
        {
          text: displayText,
          fontSize: 9,
          alignment: "center",
          margin: [5, 8, 5, 8],
          fillColor: "#d8d8d8",
          colSpan: 3, // เปลี่ยนจาก 4 เป็น 3
        },
        {},
        {},
      ];

      return {
        table: {
          widths: widths,
          body: [cells],
        },
        layout: {
          hLineWidth: function () {
            return 0;
          },
          vLineWidth: function () {
            return 1;
          },
          hLineColor: function () {
            return "black";
          },
          vLineColor: function () {
            return "black";
          },
          paddingLeft: function () {
            return 0;
          },
          paddingRight: function () {
            return 0;
          },
          paddingTop: function () {
            return 0;
          },
          paddingBottom: function () {
            return 0;
          },
        },
        margin: [0, 0, 0, 0],
      };
    },

    // 3. สร้างฟังก์ชัน generateMainReceiptDetail()
    generateMainReceiptDetail() {
      const mainContent = [];
      mainContent.push(this.createHeaderDetail());
      mainContent.push(this.createTitleDetail());
      mainContent.push(this.createCustomerInfoDetail());
      mainContent.push(this.createItemsTableDetail());
      mainContent.push(this.createSummaryTableDetail());
      mainContent.push(this.createAmountInWordsDetail());
      mainContent.push(this.createPaymentConditions());
      mainContent.push(this.createSignatureBox());
      mainContent.push(this.createFooterNote());
      return mainContent;
    },

    // 4. สร้างฟังก์ชัน generateDocDefinitionDetail()
    generateDocDefinitionDetail() {
      const mainReceiptDetail = this.generateMainReceiptDetail();
      const docDefinition = {
        pageSize: "A4",
        pageMargins: [40, 40, 40, 40],
        content: mainReceiptDetail,
        defaultStyle: {
          font: "Sarabun",
          fontSize: 10,
        },
      };
      return docDefinition;
    },

    // 5. สร้างฟังก์ชันหลัก exportReceiptDetailToPDFMake()
    async exportReceiptDetailToPDFMake() {
      // สร้างข้อมูลแล้วโยนเข้า mockData
      // this.mockData.main_data_detail = {
      //   datashowAllDetail: this.datashowAllDetail,
      //   print_header: this.print_detail_header,
      //   heighttabledetail: this.heighttabledetail,
      //   currency_print: this.currency_print,
      //   check_cus_name: this.check_cus_name,
      //   textamount_total_en: this.textamount_total_en,
      //   checklawoffice: this.checklawoffice,
      //   exchange_rate: this.exchange_rate,
      //   branch_cus: this.branch_cus,
      //   payment_by_print: this.payment_by_print,
      //   bank_name_show: this.bank_name_show,
      //   bank_no_show: this.bank_no_show,
      //   currency_show: this.currency_show,
      // };

      // // console.log(
      // //   `Mock Data Detail:`,
      // //   JSON.stringify(this.mockData.main_data_detail)
      // // );

      // try {
      //   await this.waitForPdfMakeReady();
      // } catch (error) {
      //   console.error("❌ pdfMake ไม่พร้อมใช้งาน:", error);
      //   alert("ไม่สามารถโหลดระบบ PDF ได้ กรุณาลองใหม่อีกครั้ง");
      //   return;
      // }

      // try {
      //   const docDefinition = this.generateDocDefinitionDetail();
      //   pdfMake.createPdf(docDefinition).open();
      //   console.log("✅ สร้าง Receipt Detail PDF สำเร็จ");
      // } catch (error) {
      //   console.error("❌ เกิดข้อผิดพลาดในการสร้าง PDF:", error);
      //   alert("เกิดข้อผิดพลาดในการสร้าง PDF: " + error.message);
      // }

      const receiptDetailData = {
        datashowAllDetail: this.datashowAllDetail,
        print_header: this.print_detail_header,
        heighttabledetail: this.heighttabledetail,
        currency_print: this.currency_print,
        check_cus_name: this.check_cus_name,
        textamount_total_en: this.textamount_total_en,
        checklawoffice: this.checklawoffice,
        exchange_rate: this.exchange_rate,
        branch_cus: this.branch_cus,
        payment_by_print: this.payment_by_print,
        bank_name_show: this.bank_name_show,
        bank_no_show: this.bank_no_show,
        currency_show: this.currency_show,
      };

      try {
        await generateReceiptDetailPDF(receiptDetailData);
      } catch (error) {
        alert("เกิดข้อผิดพลาดในการสร้าง PDF: " + error.message);
      }
    },
  },
  async beforeCreate() {
    //   console.log("beforeCreate");
    this.$store.state.navMenu = true;

    // this.showdefaultsignature();
  },
  async created() {
    // this.showdefaultsignature();
  },
};
</script>

<style scoped>
body {
  background: rgb(204, 204, 204);
}

.page {
  background: white;
  display: block;
  margin: 0 auto;
  margin-bottom: 0.5cm;
  /* box-shadow: 0 0 0.5cm rgba(0, 0, 0, 0.5); */
}

.page[size="A4"] {
  width: 21cm;
  height: 29.7cm;
}

.page[size="A4"][layout="landscape"] {
  width: 29.7cm;
  height: 21cm;
}

.page[size="A3"] {
  width: 29.7cm;
  height: 42cm;
}

.page[size="A3"][layout="landscape"] {
  width: 42cm;
  height: 29.7cm;
}

.page[size="A5"] {
  width: 14.8cm;
  height: 21cm;
}

.page[size="A5"][layout="landscape"] {
  width: 21cm;
  height: 14.8cm;
}

@page {
  size: 7in 9.25in;
  margin: 27mm 16mm 27mm 16mm;
}

page {
  position: relative;
  background: white;
  display: block;
  margin: 0 auto;
  line-height: 1.5;
  /* margin-bottom: 0.5cm; */
  border: 1px solid;
  /* box-shadow: 0 0 0.5cm rgba(0, 0, 0, 0.5); */
  font-family: "Roboto", sans-serif;
}

page[size="A4"] {
  width: 21cm;
  height: 29.7cm;
}

page[size="A4"][layout="portrait"] {
  width: 29.7cm;
  height: 21cm;
}

@media print {

  body,
  page {
    margin: 0;
    box-shadow: 0;
  }

  html,
  body {
    width: 210mm;
    height: 297mm;
  }
}

.page {
  display: inline-block;
  position: relative;
  height: 297mm;
  width: 210mm;
  font-size: 12pt;
  margin: 2em auto;
  padding: calc(var(--bleeding) + var(--margin));
  /* box-shadow: 0 0 0.5cm rgba(0, 0, 0, 0.5); */
  background: white;
}

@media screen {
  .page::after {
    position: absolute;
    content: "";
    top: 0;
    left: 0;
    width: calc(100% - var(--bleeding) * 2);
    height: calc(100% - var(--bleeding) * 2);
    margin: var(--bleeding);
    /* outline: thin dashed black; */
    pointer-events: none;
    z-index: 9999;
  }
}

.v-btn:not(.v-btn--round).v-size--default.buttonblue {
  background-color: #1d2442;
  color: white;
}

.btnuploadfile {
  border: 2px solid;
}

.v-btn:not(.v-btn--round).v-size--default.buttonred {
  width: 100%;
  background-color: #9e3b1b;
  color: white;
}

.v-btn:not(.v-btn--round).v-size--default.buttonwhite {
  width: 100%;
  background-color: #f5f5f5;
  color: black;
}

h3 {
  font-size: 1.17em;
}

h4 {
  font-size: 1em;
}

.frontsize {
  font-size: 14px;
}

.test {
  border-style: double;
}

.borderblack {
  border-style: solid;
  border-width: thin;
}

.mt-50 {
  margin-top: 50px;
}

.mb-50 {
  margin-bottom: 50px;
}

.btn-light {
  color: #333;
  background-color: #fafafa;
  border-color: #ddd;
}

@media (min-width: 768px) {
  .wmin-md-400 {
    min-width: 400px !important;
  }
}

.btn-primary {
  color: #fff;
  background-color: #2196f3;
}

.btn-labeled>b {
  position: absolute;
  top: -1px;
  background-color: blue;
  display: block;
  line-height: 1;
  padding: 0.62503rem;
}

.alignleft {
  float: left;
}

.alignright {
  float: right;
}

.aligncenter {
  text-align: center;
}

.captionreport {
  font-size: 0.85rem;
  font-weight: 400;
  letter-spacing: 0.0333333333em;
  line-height: 1.25rem;
  font-family: "Roboto", sans-serif;
}

.caption {
  font-size: 0.75rem;
  font-weight: 400;
  letter-spacing: 0.0333333333em;
  line-height: 1.25rem;
  font-family: "Roboto", sans-serif;
}

.captiontotal {
  font-size: 0.75rem;
  font-weight: 400;
  letter-spacing: 0.0333333333em;
  line-height: 1.8rem;
  font-family: "Roboto", sans-serif;
}

.captionhtable {
  font-size: 1rem;
  font-weight: 400;
  letter-spacing: 0.0333333333em;
  line-height: 1.25rem;
  font-family: "Roboto", sans-serif;
}

.rowprpo {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-box-flex: 1;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
  margin-right: -12px;
  margin-left: -12px;
}

.colprpo {
  -ms-flex-preferred-size: 0;
  flex-basis: 0;
  -webkit-box-flex: 1;
  -ms-flex-positive: 1;
  flex-grow: 1;
  max-width: 100%;
}

.col-md-1report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 8.333333333333333%;
  flex: 0 0 8.333333333333333%;
  max-width: 8.333333333333333%;
}

.col-md-2report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 16.66666666666667%;
  flex: 0 0 16.66666666666667%;
  max-width: 16.66666666666667%;
}

.col-md-3report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 25%;
  flex: 0 0 25%;
  max-width: 25%;
}

.col-md-4report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 33.33333333333333%;
  flex: 0 0 33.33333333333333%;
  max-width: 33.33333333333333%;
}

.col-md-5report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 41.66666666666667%;
  flex: 0 0 41.66666666666667%;
  max-width: 41.66666666666667%;
}

.col-md-6report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 50%;
  flex: 0 0 50%;
  max-width: 50%;
}

.col-md-7report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 58.33333333333333%;
  flex: 0 0 58.33333333333333%;
  max-width: 58.33333333333333%;
}

.col-md-8report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 66.66666666666667%;
  flex: 0 0 66.66666666666667%;
  max-width: 66.66666666666667%;
}

.col-md-9report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 75%;
  flex: 0 0 75%;
  max-width: 75%;
}

.col-md-10report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 83.33333333333333%;
  flex: 0 0 83.33333333333333%;
  max-width: 83.33333333333333%;
}

.col-md-11report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 91.66666666666667%;
  flex: 0 0 91.66666666666667%;
  max-width: 91.66666666666667%;
}

.col-md-12report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 100%;
  flex: 0 0 100%;
  max-width: 100%;
}

.mt-5prpo {
  margin-top: -5px !important;
}

.mrb {
  margin-right: 0px !important;
}

.mt-30prpo {
  margin-top: -30px !important;
}

.mt30 {
  margin-top: 30px !important;
}

.mt20 {
  margin-top: 20px !important;
}

.mt10 {
  margin-top: 10px !important;
}

.mt25 {
  margin-top: 25px !important;
}

.mt-25prpo {
  margin-top: -25px !important;
}

.mr30prpo {
  margin-right: 30px !important;
}

.mrRprpo {
  margin-right: 30px !important;
}

.ml30prpo {
  margin-left: 30px !important;
}

.ml2prpo {
  margin-left: 2px !important;
}

.ml10prpo {
  margin-left: 10px !important;
}

.ml-40prpo {
  margin-left: -40px !important;
}

.width45 {
  word-wrap: break-word;
  width: 45%;
}

.width50 {
  word-wrap: break-word;
  width: 50%;
}

.width55 {
  word-wrap: break-word;
  width: 50%;
}

.borderblockpr {
  border: 1px solid black;
  width: 300px;
  height: 80px;
  /* background: white; */
  /* box-sizing: border-box; */
  display: inline-block;
}

.col-md-4pr {
  -webkit-box-flex: 0;
  -ms-flex: 0 0 30%;
  flex: 0 0 30%;
  max-width: 30%;
}

.col-md-8pr {
  -webkit-box-flex: 0;
  -ms-flex: 0 0 70%;
  flex: 0 0 70%;
  max-width: 70%;
}

.col-md-4prrd {
  -webkit-box-flex: 0;
  -ms-flex: 0 0 50%;
  flex: 0 0 50%;
  max-width: 50%;
}

.col-md-8prrd {
  -webkit-box-flex: 0;
  -ms-flex: 0 0 50%;
  flex: 0 0 50%;
  max-width: 50%;
}

.textalignleft {
  text-align: left;
}

.textaligncenter {
  text-align: center;
}

table {
  table-layout: fixed;
  border-collapse: collapse;
  width: 100%;
  /* border: 1px solid black; */
}

.prbordertop {
  border-top: 1px solid black;
}

.prborderbottom {
  border-bottom: 1px solid black;
}

.prbordertop2pxhtable {
  padding-top: 8px;
  /* border-top: 1px solid black; */
}

.prborderbottom2pxhtable {
  padding-bottom: 8px;
  border-bottom: 1px solid black;
}

td {
  /* border: 1px solid black; */
}

td.tdborder-top {
  border-top: 1px solid black;
}

td.tdborder-right {
  border-right: 1px solid black;
}

td.tdborder-left {
  border-left: 1px solid black;
}

td.tdborder-bottom {
  border-bottom: 1px solid black;
}

th {
  /* border: 1px solid black; */
}

th.thborder-top {
  border-top: 1px solid black;
}

th.thborder-right {
  border-right: 1px solid black;
}

th.thborder-left {
  border-left: 1px solid black;
}

th.thborder-bottom {
  border-bottom: 1px solid black;
}

.width15 {
  word-wrap: break-word;
  width: 15%;
}

.width10 {
  word-wrap: break-word;
  width: 10%;
}

.width20 {
  word-wrap: break-word;
  width: 20%;
}

.width30 {
  word-wrap: break-word;
  width: 30%;
}

.width120 {
  word-wrap: break-word;
  width: 120%;
}

.widthcolNo {
  word-wrap: break-word;
  width: 61px;
}

.widthcolNoOth {
  word-wrap: break-word;
  width: 46px;
}

.widthinvNo {
  word-wrap: break-word;
  width: 244px;
}

.widthinvNoOth {
  word-wrap: break-word;
  width: 183px;
}

.widthDate {
  word-wrap: break-word;
  width: 183px;
}

.widthDateOth {
  word-wrap: break-word;
  width: 137px;
}

.widthCredit {
  word-wrap: break-word;
  width: 148%;
}

.widthCurrency {
  word-wrap: break-word;
  width: 112%;
}

.widthCurrencyOth {
  word-wrap: break-word;
  width: 183px;
}

.widthAmount {
  word-wrap: break-word;
  width: 243px;
}

.widthAmountOth {
  word-wrap: break-word;
  width: 183px;
}

.widthinvDate {
  word-wrap: break-word;
  width: 112%;
}

.widthcolDesDetail {
  word-wrap: break-word;
  width: 110%;
}

.width40 {
  word-wrap: break-word;
  width: 40%;
}

.width50 {
  word-wrap: break-word;
  width: 50%;
}

.width60 {
  word-wrap: break-word;
  width: 60%;
}

.width70 {
  word-wrap: break-word;
  width: 70%;
}

.width75 {
  word-wrap: break-word;
  width: 75%;
}

.width25 {
  word-wrap: break-word;
  width: 25%;
}

.width80 {
  word-wrap: break-word;
  width: 80%;
}

.width85 {
  word-wrap: break-word;
  width: 85%;
}

.width90 {
  word-wrap: break-word;
  width: 90%;
}

.width100 {
  word-wrap: break-word;
  width: 100%;
}

.widthDesDetail {
  word-wrap: break-word;
  width: 110%;
}

.widthTotal {
  word-wrap: break-word;
  width: 140%;
}

.widthValOri {
  word-wrap: break-word;
  width: 40%;
}

.widthfull {
  width: 100%;
}

.widthVal {
  word-wrap: break-word;
  width: 243px;
}

.widthValOth {
  word-wrap: break-word;
  width: 183px;
}

@media print {

  /*
          body.A3.landscape { width: 420mm }
          body.A3, body.A4.landscape { width: 297mm }
          body.A4, body.A5.landscape { width: 210mm }
          body.A5 { width: 148mm }*/
  .printonly {
    display: block;
  }

  .noprint {
    display: none;
  }

  .A3.landscape {
    width: 420mm;
  }

  .A3,
  .A4.landscape {
    width: 297mm;
  }

  .A4,
  .A5.landscape {
    width: 210mm;
  }

  .A5 {
    width: 148mm;
  }
}

header {
  top: 0;
  padding-top: 150mm;
  padding-bottom: 3mm;
}

footer {
  bottom: 0;
  color: #000;
  padding-top: 3mm;
  padding-bottom: 5mm;
}

header,
footer {
  /* position: fixed; */
  left: 0;
  right: 0;
  background-color: #ccc;
  padding-right: 1.5cm;
  padding-left: 1.5cm;
}

.footerprpo {
  position: absolute;
  width: 100%;
}

.borderauto {
  border: 1px solid;
  margin: -1px;
}

.bordersignature {
  height: 110px;
  border: 1px solid;
  margin: -1px;
}

.full-width-td {
  width: 100%;
}

.fixfourrow {
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  height: 80px;
  overflow: hidden;
  text-align: left;
}

.higthR {
  height: 50px;
}

.higthRP {
  height: 10px;
}

.fixthreerow {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  height: 60px;
  overflow: hidden;
  text-align: left;
}

.fixthreerownoheight {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-align: left;
}

.fontweight700 {
  font-weight: 700;
}

.fixtworow {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  height: 40px;
  overflow: hidden;
  text-align: left;
}

.fixonerow {
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  height: 20px;
  overflow: hidden;
  text-align: left;
}

.fixonerownoheight {
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-align: left;
}

.fixonerowcenter {
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  height: 20px;
  overflow: hidden;
  text-align: center;
}

.fontsize10 {
  font-size: 10px;
}

.fontsize12 {
  font-size: 12px;
}

.fontsize13 {
  font-size: 12px;
}

.borderwidththin {
  border-width: thin;
  border-color: darkgray;
}

.titledatadetailintable {
  font-weight: bold;
  text-decoration: underline;
}

.paddingleftintable {
  padding-left: 10px;
}

.paddingrightintable {
  padding-right: 10px;
}

.paddingtoptintable {
  padding-top: 10px;
}

.paddingrightintableleft {
  padding-left: 10px;
}

.paddingrightintableInv {
  padding-left: 50px;
}

.textalignright {
  text-align: right;
}

.textindent {
  text-indent: -20px;
}

.wordspacingsummary {
  /* word-spacing: -1px; */
  letter-spacing: 1px;
}

.fontsize14 {
  font-size: 14px;
}

.customClass>>>label {
  font-size: 13px;
  color: #000;
}
</style>
